import * as re from "react";
import Ke, { createContext as Pn, useContext as In, useState as ee, useRef as J, useEffect as z, useCallback as ne, useMemo as ze } from "react";
import An from "@arcgis/core/layers/GraphicsLayer.js";
import Nn from "@arcgis/core/Graphic";
import * as Cr from "@arcgis/core/geometry/support/jsonUtils";
import { useTranslation as jn } from "react-i18next";
import { CalciteTooltip as Ln } from "@esri/calcite-components-react/dist";
import er from "@arcgis/core/Map";
import Vn from "@arcgis/core/WebMap";
import Fn from "@arcgis/core/WebScene";
import zn from "@arcgis/core/views/MapView";
import Gn from "@arcgis/core/views/SceneView";
import X from "@arcgis/core/Basemap";
import ce from "@arcgis/core/layers/VectorTileLayer";
import Tr from "@arcgis/core/geometry/Point";
import { createLogger as Te } from "@origo/logger";
import Or from "@arcgis/core/layers/TileLayer";
import $n from "@arcgis/core/layers/MapImageLayer";
import Un from "@arcgis/core/layers/SceneLayer";
import Hn from "@arcgis/core/layers/ElevationLayer";
import Bn from "@arcgis/core/Ground";
import Wn from "@arcgis/core/widgets/BasemapGallery/support/LocalBasemapsSource";
import Ot from "@arcgis/core/layers/FeatureLayer";
import Kn from "@arcgis/core/renderers/SimpleRenderer";
import Yn from "@arcgis/core/symbols/SimpleFillSymbol";
import Jn from "@arcgis/core/renderers/UniqueValueRenderer";
import qn from "@arcgis/core/symbols/CIMSymbol";
import * as q from "@arcgis/core/core/reactiveUtils";
import Ye from "@arcgis/core/widgets/Expand";
import Xn from "@arcgis/core/widgets/BasemapGallery";
import Qn from "@arcgis/core/widgets/AreaMeasurement3D";
import Zn from "@arcgis/core/widgets/Daylight";
import eo from "@arcgis/core/widgets/ShadowCast";
import * as to from "@arcgis/core/geometry/operators/geodeticAreaOperator";
import * as ro from "@arcgis/core/geometry/operators/geodeticDensifyOperator";
import * as no from "@arcgis/core/geometry/operators/geodeticLengthOperator";
import "@arcgis/map-components/dist/components/arcgis-fullscreen";
import "@arcgis/map-components/dist/components/arcgis-scale-bar";
import "@arcgis/map-components/dist/components/arcgis-expand";
import "@arcgis/map-components/dist/components/arcgis-area-measurement-2d";
import $e from "@arcgis/core/support/actions/ActionButton";
var gt = { exports: {} }, ve = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var tr;
function oo() {
  if (tr)
    return ve;
  tr = 1;
  var e = Ke, t = Symbol.for("react.element"), r = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, i = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, a = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, c, f) {
    var u, h = {}, w = null, E = null;
    f !== void 0 && (w = "" + f), c.key !== void 0 && (w = "" + c.key), c.ref !== void 0 && (E = c.ref);
    for (u in c)
      n.call(c, u) && !a.hasOwnProperty(u) && (h[u] = c[u]);
    if (l && l.defaultProps)
      for (u in c = l.defaultProps, c)
        h[u] === void 0 && (h[u] = c[u]);
    return { $$typeof: t, type: l, key: w, ref: E, props: h, _owner: i.current };
  }
  return ve.Fragment = r, ve.jsx = s, ve.jsxs = s, ve;
}
var Ee = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var rr;
function io() {
  return rr || (rr = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Ke, t = Symbol.for("react.element"), r = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), f = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), h = Symbol.for("react.memo"), w = Symbol.for("react.lazy"), E = Symbol.for("react.offscreen"), p = Symbol.iterator, _ = "@@iterator";
    function R(o) {
      if (o === null || typeof o != "object")
        return null;
      var d = p && o[p] || o[_];
      return typeof d == "function" ? d : null;
    }
    var C = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function v(o) {
      {
        for (var d = arguments.length, m = new Array(d > 1 ? d - 1 : 0), S = 1; S < d; S++)
          m[S - 1] = arguments[S];
        b("error", o, m);
      }
    }
    function b(o, d, m) {
      {
        var S = C.ReactDebugCurrentFrame, x = S.getStackAddendum();
        x !== "" && (d += "%s", m = m.concat([x]));
        var D = m.map(function(O) {
          return String(O);
        });
        D.unshift("Warning: " + d), Function.prototype.apply.call(console[o], console, D);
      }
    }
    var g = !1, y = !1, k = !1, M = !1, P = !1, $;
    $ = Symbol.for("react.module.reference");
    function K(o) {
      return !!(typeof o == "string" || typeof o == "function" || o === n || o === a || P || o === i || o === f || o === u || M || o === E || g || y || k || typeof o == "object" && o !== null && (o.$$typeof === w || o.$$typeof === h || o.$$typeof === s || o.$$typeof === l || o.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      o.$$typeof === $ || o.getModuleId !== void 0));
    }
    function H(o, d, m) {
      var S = o.displayName;
      if (S)
        return S;
      var x = d.displayName || d.name || "";
      return x !== "" ? m + "(" + x + ")" : m;
    }
    function he(o) {
      return o.displayName || "Context";
    }
    function B(o) {
      if (o == null)
        return null;
      if (typeof o.tag == "number" && v("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof o == "function")
        return o.displayName || o.name || null;
      if (typeof o == "string")
        return o;
      switch (o) {
        case n:
          return "Fragment";
        case r:
          return "Portal";
        case a:
          return "Profiler";
        case i:
          return "StrictMode";
        case f:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof o == "object")
        switch (o.$$typeof) {
          case l:
            var d = o;
            return he(d) + ".Consumer";
          case s:
            var m = o;
            return he(m._context) + ".Provider";
          case c:
            return H(o, o.render, "ForwardRef");
          case h:
            var S = o.displayName || null;
            return S !== null ? S : B(o.type) || "Memo";
          case w: {
            var x = o, D = x._payload, O = x._init;
            try {
              return B(O(D));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var A = Object.assign, Y = 0, Z, fe, pe, xe, jt, Lt, Vt;
    function Ft() {
    }
    Ft.__reactDisabledLog = !0;
    function on() {
      {
        if (Y === 0) {
          Z = console.log, fe = console.info, pe = console.warn, xe = console.error, jt = console.group, Lt = console.groupCollapsed, Vt = console.groupEnd;
          var o = {
            configurable: !0,
            enumerable: !0,
            value: Ft,
            writable: !0
          };
          Object.defineProperties(console, {
            info: o,
            log: o,
            warn: o,
            error: o,
            group: o,
            groupCollapsed: o,
            groupEnd: o
          });
        }
        Y++;
      }
    }
    function an() {
      {
        if (Y--, Y === 0) {
          var o = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: A({}, o, {
              value: Z
            }),
            info: A({}, o, {
              value: fe
            }),
            warn: A({}, o, {
              value: pe
            }),
            error: A({}, o, {
              value: xe
            }),
            group: A({}, o, {
              value: jt
            }),
            groupCollapsed: A({}, o, {
              value: Lt
            }),
            groupEnd: A({}, o, {
              value: Vt
            })
          });
        }
        Y < 0 && v("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ze = C.ReactCurrentDispatcher, et;
    function Me(o, d, m) {
      {
        if (et === void 0)
          try {
            throw Error();
          } catch (x) {
            var S = x.stack.trim().match(/\n( *(at )?)/);
            et = S && S[1] || "";
          }
        return `
` + et + o;
      }
    }
    var tt = !1, De;
    {
      var sn = typeof WeakMap == "function" ? WeakMap : Map;
      De = new sn();
    }
    function zt(o, d) {
      if (!o || tt)
        return "";
      {
        var m = De.get(o);
        if (m !== void 0)
          return m;
      }
      var S;
      tt = !0;
      var x = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var D;
      D = Ze.current, Ze.current = null, on();
      try {
        if (d) {
          var O = function() {
            throw Error();
          };
          if (Object.defineProperty(O.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(O, []);
            } catch (F) {
              S = F;
            }
            Reflect.construct(o, [], O);
          } else {
            try {
              O.call();
            } catch (F) {
              S = F;
            }
            o.call(O.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (F) {
            S = F;
          }
          o();
        }
      } catch (F) {
        if (F && S && typeof F.stack == "string") {
          for (var T = F.stack.split(`
`), V = S.stack.split(`
`), I = T.length - 1, N = V.length - 1; I >= 1 && N >= 0 && T[I] !== V[N]; )
            N--;
          for (; I >= 1 && N >= 0; I--, N--)
            if (T[I] !== V[N]) {
              if (I !== 1 || N !== 1)
                do
                  if (I--, N--, N < 0 || T[I] !== V[N]) {
                    var W = `
` + T[I].replace(" at new ", " at ");
                    return o.displayName && W.includes("<anonymous>") && (W = W.replace("<anonymous>", o.displayName)), typeof o == "function" && De.set(o, W), W;
                  }
                while (I >= 1 && N >= 0);
              break;
            }
        }
      } finally {
        tt = !1, Ze.current = D, an(), Error.prepareStackTrace = x;
      }
      var ye = o ? o.displayName || o.name : "", ie = ye ? Me(ye) : "";
      return typeof o == "function" && De.set(o, ie), ie;
    }
    function cn(o, d, m) {
      return zt(o, !1);
    }
    function ln(o) {
      var d = o.prototype;
      return !!(d && d.isReactComponent);
    }
    function Pe(o, d, m) {
      if (o == null)
        return "";
      if (typeof o == "function")
        return zt(o, ln(o));
      if (typeof o == "string")
        return Me(o);
      switch (o) {
        case f:
          return Me("Suspense");
        case u:
          return Me("SuspenseList");
      }
      if (typeof o == "object")
        switch (o.$$typeof) {
          case c:
            return cn(o.render);
          case h:
            return Pe(o.type, d, m);
          case w: {
            var S = o, x = S._payload, D = S._init;
            try {
              return Pe(D(x), d, m);
            } catch {
            }
          }
        }
      return "";
    }
    var ge = Object.prototype.hasOwnProperty, Gt = {}, $t = C.ReactDebugCurrentFrame;
    function Ie(o) {
      if (o) {
        var d = o._owner, m = Pe(o.type, o._source, d ? d.type : null);
        $t.setExtraStackFrame(m);
      } else
        $t.setExtraStackFrame(null);
    }
    function un(o, d, m, S, x) {
      {
        var D = Function.call.bind(ge);
        for (var O in o)
          if (D(o, O)) {
            var T = void 0;
            try {
              if (typeof o[O] != "function") {
                var V = Error((S || "React class") + ": " + m + " type `" + O + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[O] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw V.name = "Invariant Violation", V;
              }
              T = o[O](d, O, S, m, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (I) {
              T = I;
            }
            T && !(T instanceof Error) && (Ie(x), v("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", S || "React class", m, O, typeof T), Ie(null)), T instanceof Error && !(T.message in Gt) && (Gt[T.message] = !0, Ie(x), v("Failed %s type: %s", m, T.message), Ie(null));
          }
      }
    }
    var dn = Array.isArray;
    function rt(o) {
      return dn(o);
    }
    function fn(o) {
      {
        var d = typeof Symbol == "function" && Symbol.toStringTag, m = d && o[Symbol.toStringTag] || o.constructor.name || "Object";
        return m;
      }
    }
    function pn(o) {
      try {
        return Ut(o), !1;
      } catch {
        return !0;
      }
    }
    function Ut(o) {
      return "" + o;
    }
    function Ht(o) {
      if (pn(o))
        return v("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", fn(o)), Ut(o);
    }
    var be = C.ReactCurrentOwner, mn = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Bt, Wt, nt;
    nt = {};
    function yn(o) {
      if (ge.call(o, "ref")) {
        var d = Object.getOwnPropertyDescriptor(o, "ref").get;
        if (d && d.isReactWarning)
          return !1;
      }
      return o.ref !== void 0;
    }
    function hn(o) {
      if (ge.call(o, "key")) {
        var d = Object.getOwnPropertyDescriptor(o, "key").get;
        if (d && d.isReactWarning)
          return !1;
      }
      return o.key !== void 0;
    }
    function gn(o, d) {
      if (typeof o.ref == "string" && be.current && d && be.current.stateNode !== d) {
        var m = B(be.current.type);
        nt[m] || (v('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', B(be.current.type), o.ref), nt[m] = !0);
      }
    }
    function bn(o, d) {
      {
        var m = function() {
          Bt || (Bt = !0, v("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", d));
        };
        m.isReactWarning = !0, Object.defineProperty(o, "key", {
          get: m,
          configurable: !0
        });
      }
    }
    function vn(o, d) {
      {
        var m = function() {
          Wt || (Wt = !0, v("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", d));
        };
        m.isReactWarning = !0, Object.defineProperty(o, "ref", {
          get: m,
          configurable: !0
        });
      }
    }
    var En = function(o, d, m, S, x, D, O) {
      var T = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: o,
        key: d,
        ref: m,
        props: O,
        // Record the component responsible for creating this element.
        _owner: D
      };
      return T._store = {}, Object.defineProperty(T._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(T, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: S
      }), Object.defineProperty(T, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: x
      }), Object.freeze && (Object.freeze(T.props), Object.freeze(T)), T;
    };
    function _n(o, d, m, S, x) {
      {
        var D, O = {}, T = null, V = null;
        m !== void 0 && (Ht(m), T = "" + m), hn(d) && (Ht(d.key), T = "" + d.key), yn(d) && (V = d.ref, gn(d, x));
        for (D in d)
          ge.call(d, D) && !mn.hasOwnProperty(D) && (O[D] = d[D]);
        if (o && o.defaultProps) {
          var I = o.defaultProps;
          for (D in I)
            O[D] === void 0 && (O[D] = I[D]);
        }
        if (T || V) {
          var N = typeof o == "function" ? o.displayName || o.name || "Unknown" : o;
          T && bn(O, N), V && vn(O, N);
        }
        return En(o, T, V, x, S, be.current, O);
      }
    }
    var ot = C.ReactCurrentOwner, Kt = C.ReactDebugCurrentFrame;
    function me(o) {
      if (o) {
        var d = o._owner, m = Pe(o.type, o._source, d ? d.type : null);
        Kt.setExtraStackFrame(m);
      } else
        Kt.setExtraStackFrame(null);
    }
    var it;
    it = !1;
    function at(o) {
      return typeof o == "object" && o !== null && o.$$typeof === t;
    }
    function Yt() {
      {
        if (ot.current) {
          var o = B(ot.current.type);
          if (o)
            return `

Check the render method of \`` + o + "`.";
        }
        return "";
      }
    }
    function wn(o) {
      {
        if (o !== void 0) {
          var d = o.fileName.replace(/^.*[\\\/]/, ""), m = o.lineNumber;
          return `

Check your code at ` + d + ":" + m + ".";
        }
        return "";
      }
    }
    var Jt = {};
    function kn(o) {
      {
        var d = Yt();
        if (!d) {
          var m = typeof o == "string" ? o : o.displayName || o.name;
          m && (d = `

Check the top-level render call using <` + m + ">.");
        }
        return d;
      }
    }
    function qt(o, d) {
      {
        if (!o._store || o._store.validated || o.key != null)
          return;
        o._store.validated = !0;
        var m = kn(d);
        if (Jt[m])
          return;
        Jt[m] = !0;
        var S = "";
        o && o._owner && o._owner !== ot.current && (S = " It was passed a child from " + B(o._owner.type) + "."), me(o), v('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', m, S), me(null);
      }
    }
    function Xt(o, d) {
      {
        if (typeof o != "object")
          return;
        if (rt(o))
          for (var m = 0; m < o.length; m++) {
            var S = o[m];
            at(S) && qt(S, d);
          }
        else if (at(o))
          o._store && (o._store.validated = !0);
        else if (o) {
          var x = R(o);
          if (typeof x == "function" && x !== o.entries)
            for (var D = x.call(o), O; !(O = D.next()).done; )
              at(O.value) && qt(O.value, d);
        }
      }
    }
    function Sn(o) {
      {
        var d = o.type;
        if (d == null || typeof d == "string")
          return;
        var m;
        if (typeof d == "function")
          m = d.propTypes;
        else if (typeof d == "object" && (d.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        d.$$typeof === h))
          m = d.propTypes;
        else
          return;
        if (m) {
          var S = B(d);
          un(m, o.props, "prop", S, o);
        } else if (d.PropTypes !== void 0 && !it) {
          it = !0;
          var x = B(d);
          v("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", x || "Unknown");
        }
        typeof d.getDefaultProps == "function" && !d.getDefaultProps.isReactClassApproved && v("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Rn(o) {
      {
        for (var d = Object.keys(o.props), m = 0; m < d.length; m++) {
          var S = d[m];
          if (S !== "children" && S !== "key") {
            me(o), v("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", S), me(null);
            break;
          }
        }
        o.ref !== null && (me(o), v("Invalid attribute `ref` supplied to `React.Fragment`."), me(null));
      }
    }
    var Qt = {};
    function Zt(o, d, m, S, x, D) {
      {
        var O = K(o);
        if (!O) {
          var T = "";
          (o === void 0 || typeof o == "object" && o !== null && Object.keys(o).length === 0) && (T += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var V = wn(x);
          V ? T += V : T += Yt();
          var I;
          o === null ? I = "null" : rt(o) ? I = "array" : o !== void 0 && o.$$typeof === t ? (I = "<" + (B(o.type) || "Unknown") + " />", T = " Did you accidentally export a JSX literal instead of a component?") : I = typeof o, v("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", I, T);
        }
        var N = _n(o, d, m, x, D);
        if (N == null)
          return N;
        if (O) {
          var W = d.children;
          if (W !== void 0)
            if (S)
              if (rt(W)) {
                for (var ye = 0; ye < W.length; ye++)
                  Xt(W[ye], o);
                Object.freeze && Object.freeze(W);
              } else
                v("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Xt(W, o);
        }
        if (ge.call(d, "key")) {
          var ie = B(o), F = Object.keys(d).filter(function(Dn) {
            return Dn !== "key";
          }), st = F.length > 0 ? "{key: someKey, " + F.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Qt[ie + st]) {
            var Mn = F.length > 0 ? "{" + F.join(": ..., ") + ": ...}" : "{}";
            v(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, st, ie, Mn, ie), Qt[ie + st] = !0;
          }
        }
        return o === n ? Rn(N) : Sn(N), N;
      }
    }
    function Cn(o, d, m) {
      return Zt(o, d, m, !0);
    }
    function Tn(o, d, m) {
      return Zt(o, d, m, !1);
    }
    var On = Tn, xn = Cn;
    Ee.Fragment = n, Ee.jsx = On, Ee.jsxs = xn;
  }()), Ee;
}
process.env.NODE_ENV === "production" ? gt.exports = oo() : gt.exports = io();
var te = gt.exports;
const ao = (e) => e.type ? e : Cr.fromJSON(e), so = (e, t, r) => {
  const n = ao(e);
  if (!n)
    throw new Error("Invalid geometry provided.");
  return e = n, new Nn({
    geometry: e,
    attributes: r,
    symbol: t
  });
}, co = 400, lo = "ease-out", uo = 250, fo = () => typeof window < "u" && window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
function po(e, t, r, n) {
  const i = 3 * e, a = 3 * (r - e) - i, s = 1 - i - a, l = 3 * t, c = 3 * (n - t) - l, f = 1 - l - c, u = (p) => ((s * p + a) * p + i) * p, h = (p) => ((f * p + c) * p + l) * p, w = (p) => (3 * s * p + 2 * a) * p + i;
  function E(p) {
    let _ = p;
    for (let v = 0; v < 8; v++) {
      const b = u(_) - p;
      if (Math.abs(b) < 1e-6)
        return _;
      const g = w(_);
      if (Math.abs(g) < 1e-6)
        break;
      _ -= b / g;
    }
    let R = 0, C = 1;
    for (_ = p; R < C; ) {
      const v = u(_);
      if (Math.abs(v - p) < 1e-6)
        return _;
      p > v ? R = _ : C = _, _ = (C - R) / 2 + R;
    }
    return _;
  }
  return (p) => h(E(p));
}
const mo = po(0.2, 0, 0, 1), oe = /* @__PURE__ */ new WeakMap(), yo = (e) => e.padding?.bottom ?? 0, Ue = (e, t) => {
  e.padding = { ...e.padding, bottom: t };
};
function ho(e, t) {
  oe.get(e)?.cancel(), oe.delete(e), Ue(e, t);
}
function go(e) {
  const t = oe.get(e);
  t && (t.cancel(), oe.delete(e), Ue(e, t.target));
}
function bo(e, t) {
  if (oe.get(e)?.cancel(), fo()) {
    oe.delete(e), Ue(e, t);
    return;
  }
  const r = yo(e), n = performance.now();
  let i = !1, a;
  const s = (l) => {
    if (i)
      return;
    const c = Math.min(1, (l - n) / uo);
    Ue(e, r + (t - r) * mo(c)), c < 1 ? a = requestAnimationFrame(s) : oe.delete(e);
  };
  oe.set(e, {
    target: t,
    cancel: () => {
      i = !0, cancelAnimationFrame(a);
    }
  }), a = requestAnimationFrame(s);
}
function vo(e, t, r) {
  if (e)
    return go(e), e.goTo(t, { duration: co, easing: lo, ...r });
}
const ct = {
  ID: "highlight_layer",
  LIST_MODE: "hide",
  VISIBLE: !0
}, nr = (e, t) => {
  e?.map?.add(t);
}, or = (e, t) => {
  e?.map?.layers.includes(t) && e.map.remove(t);
}, ir = (e, t) => e || t, Eo = (e, t) => e.map((r) => so(r, t));
var _e = /* @__PURE__ */ ((e) => (e.TwoD = "2D", e.ThreeD = "3D", e))(_e || {});
const xr = Pn({
  mapView: null,
  setMapView: () => {
  },
  sceneView: null,
  setSceneView: () => {
  },
  highlightGeometries: () => {
  },
  clearHighlights: () => {
  },
  graphicsLayer: null,
  currentHighlights: null,
  currentSymbol: null,
  onMapClick: void 0,
  // Default values for new properties
  mapMode: "2D",
  setMapMode: () => {
  },
  toggleMapMode: () => {
  },
  widgetConfig: void 0,
  setWidgetConfig: () => {
  },
  disableMapClick: !1,
  setDisableMapClick: () => {
  },
  setBottomInset: () => {
  },
  onLocationChange: void 0,
  onWidgetActivation: void 0
}), _o = () => In(xr), Qa = ({
  children: e,
  onMapClick: t,
  onLocationChange: r,
  onWidgetActivation: n,
  initialMapMode: i = "2D",
  widgetConfig: a
}) => {
  const [s, l] = ee(null), [c, f] = ee(null), [u, h] = ee(null), [w, E] = ee(null), [p, _] = ee(null), [R, C] = ee(i), [v, b] = ee(a || {}), [g, y] = ee(!1), k = J(null), M = J(null), P = J(null);
  z(() => {
    k.current = u;
  }, [u]), z(() => {
    M.current = s;
  }, [s]), z(() => {
    P.current = c;
  }, [c]), z(() => {
    const A = new An({
      id: ct.ID,
      listMode: ct.LIST_MODE,
      visible: ct.VISIBLE
    });
    h(A);
  }, []), z(() => {
    if (u)
      return nr(s, u), nr(c, u), () => {
        or(s, u), or(c, u);
      };
  }, [s, c, u]);
  const $ = ne((A, Y, Z = !1) => {
    const fe = k.current;
    if (!fe)
      return;
    E(A), _(Y), fe.removeAll();
    const pe = Eo(A, Y);
    if (fe.addMany(pe), Z && pe.length > 0) {
      const xe = ir(M.current, P.current);
      vo(xe, pe);
    }
  }, []), K = ne(() => {
    const A = k.current;
    A && (A.removeAll(), E(null), _(null));
  }, []), H = ne(() => {
    C(
      (A) => A === "2D" ? "3D" : "2D"
      /* TwoD */
    );
  }, []), he = ne((A, Y) => {
    const Z = ir(M.current, P.current);
    Z && (Y?.immediate ? ho(Z, A) : bo(Z, A));
  }, []), B = ze(() => ({
    mapView: s,
    setMapView: l,
    sceneView: c,
    setSceneView: f,
    highlightGeometries: $,
    clearHighlights: K,
    graphicsLayer: u,
    currentHighlights: w,
    currentSymbol: p,
    onMapClick: t,
    mapMode: R,
    setMapMode: C,
    toggleMapMode: H,
    widgetConfig: v,
    setWidgetConfig: b,
    disableMapClick: g,
    setDisableMapClick: y,
    setBottomInset: he,
    onLocationChange: r,
    onWidgetActivation: n
  }), [
    s,
    c,
    $,
    K,
    u,
    w,
    p,
    t,
    R,
    H,
    v,
    g,
    he,
    r,
    n
  ]);
  return /* @__PURE__ */ te.jsx(xr.Provider, { value: B, children: e });
}, xt = [0, 55, 248];
function Mt(e, t) {
  if (typeof document > "u")
    return t;
  const r = getComputedStyle(document.documentElement).getPropertyValue(e).trim();
  if (!r)
    return t;
  const n = r.match(/^#([0-9a-f]{3}|[0-9a-f]{6})$/i);
  if (n) {
    const a = n[1].length === 3 ? n[1].split("").map((l) => l + l).join("") : n[1], s = parseInt(a, 16);
    return [s >> 16 & 255, s >> 8 & 255, s & 255];
  }
  const i = r.match(/rgba?\s*\(\s*(\d+)[\s,]+(\d+)[\s,]+(\d+)/i);
  return i ? [Number(i[1]), Number(i[2]), Number(i[3])] : t;
}
function Za() {
  const [e, t, r] = Mt("--map-selection", xt);
  return {
    type: "simple-fill",
    color: [e, t, r, 0.12],
    outline: {
      color: [e, t, r, 1],
      width: 2
    }
  };
}
function es() {
  const [e, t, r] = Mt("--map-selection", xt);
  return {
    type: "simple-marker",
    color: [e, t, r, 1],
    size: 10,
    outline: {
      color: [255, 255, 255, 1],
      width: 2
    }
  };
}
function ts() {
  return {
    type: "simple-fill",
    color: [255, 255, 0, 0.3],
    outline: {
      color: [255, 0, 0, 1],
      width: 2
    }
  };
}
function rs() {
  const [e, t, r] = Mt("--map-selection", xt);
  return {
    type: "simple-fill",
    color: [0, 0, 0, 0],
    outline: {
      style: "short-dash",
      color: [e, t, r, 0.7],
      width: 1.5
    }
  };
}
var bt = { exports: {} }, lt = {};
/**
 * @license React
 * use-sync-external-store-with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ar;
function wo() {
  if (ar)
    return lt;
  ar = 1;
  var e = Ke;
  function t(c, f) {
    return c === f && (c !== 0 || 1 / c === 1 / f) || c !== c && f !== f;
  }
  var r = typeof Object.is == "function" ? Object.is : t, n = e.useSyncExternalStore, i = e.useRef, a = e.useEffect, s = e.useMemo, l = e.useDebugValue;
  return lt.useSyncExternalStoreWithSelector = function(c, f, u, h, w) {
    var E = i(null);
    if (E.current === null) {
      var p = { hasValue: !1, value: null };
      E.current = p;
    } else
      p = E.current;
    E = s(
      function() {
        function R(y) {
          if (!C) {
            if (C = !0, v = y, y = h(y), w !== void 0 && p.hasValue) {
              var k = p.value;
              if (w(k, y))
                return b = k;
            }
            return b = y;
          }
          if (k = b, r(v, y))
            return k;
          var M = h(y);
          return w !== void 0 && w(k, M) ? (v = y, k) : (v = y, b = M);
        }
        var C = !1, v, b, g = u === void 0 ? null : u;
        return [
          function() {
            return R(f());
          },
          g === null ? void 0 : function() {
            return R(g());
          }
        ];
      },
      [f, u, h, w]
    );
    var _ = n(c, E[0], E[1]);
    return a(
      function() {
        p.hasValue = !0, p.value = _;
      },
      [_]
    ), l(_), _;
  }, lt;
}
var ut = {};
/**
 * @license React
 * use-sync-external-store-with-selector.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var sr;
function ko() {
  return sr || (sr = 1, process.env.NODE_ENV !== "production" && function() {
    function e(c, f) {
      return c === f && (c !== 0 || 1 / c === 1 / f) || c !== c && f !== f;
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var t = Ke, r = typeof Object.is == "function" ? Object.is : e, n = t.useSyncExternalStore, i = t.useRef, a = t.useEffect, s = t.useMemo, l = t.useDebugValue;
    ut.useSyncExternalStoreWithSelector = function(c, f, u, h, w) {
      var E = i(null);
      if (E.current === null) {
        var p = { hasValue: !1, value: null };
        E.current = p;
      } else
        p = E.current;
      E = s(
        function() {
          function R(y) {
            if (!C) {
              if (C = !0, v = y, y = h(y), w !== void 0 && p.hasValue) {
                var k = p.value;
                if (w(k, y))
                  return b = k;
              }
              return b = y;
            }
            if (k = b, r(v, y))
              return k;
            var M = h(y);
            return w !== void 0 && w(k, M) ? (v = y, k) : (v = y, b = M);
          }
          var C = !1, v, b, g = u === void 0 ? null : u;
          return [
            function() {
              return R(f());
            },
            g === null ? void 0 : function() {
              return R(g());
            }
          ];
        },
        [f, u, h, w]
      );
      var _ = n(c, E[0], E[1]);
      return a(
        function() {
          p.hasValue = !0, p.value = _;
        },
        [_]
      ), l(_), _;
    }, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), ut;
}
process.env.NODE_ENV === "production" ? bt.exports = wo() : bt.exports = ko();
var So = bt.exports, dt = /* @__PURE__ */ Symbol.for("react-redux-context"), ft = typeof globalThis < "u" ? globalThis : (
  /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */
  {}
);
function Ro() {
  if (!re.createContext)
    return {};
  const e = ft[dt] ?? (ft[dt] = /* @__PURE__ */ new Map());
  let t = e.get(re.createContext);
  return t || (t = re.createContext(
    null
  ), process.env.NODE_ENV !== "production" && (t.displayName = "ReactRedux"), e.set(re.createContext, t)), t;
}
var le = /* @__PURE__ */ Ro();
function Dt(e = le) {
  return function() {
    const r = re.useContext(e);
    if (process.env.NODE_ENV !== "production" && !r)
      throw new Error(
        "could not find react-redux context value; please ensure the component is wrapped in a <Provider>"
      );
    return r;
  };
}
var Mr = /* @__PURE__ */ Dt();
function Dr(e = le) {
  const t = e === le ? Mr : (
    // @ts-ignore
    Dt(e)
  ), r = () => {
    const { store: n } = t();
    return n;
  };
  return Object.assign(r, {
    withTypes: () => r
  }), r;
}
var Co = /* @__PURE__ */ Dr();
function To(e = le) {
  const t = e === le ? Co : Dr(e), r = () => t().dispatch;
  return Object.assign(r, {
    withTypes: () => r
  }), r;
}
var Oo = /* @__PURE__ */ To(), xo = (e, t) => e === t;
function Mo(e = le) {
  const t = e === le ? Mr : Dt(e), r = (n, i = {}) => {
    const { equalityFn: a = xo } = typeof i == "function" ? { equalityFn: i } : i;
    if (process.env.NODE_ENV !== "production") {
      if (!n)
        throw new Error("You must pass a selector to useSelector");
      if (typeof n != "function")
        throw new Error("You must pass a function as a selector to useSelector");
      if (typeof a != "function")
        throw new Error(
          "You must pass a function as an equality function to useSelector"
        );
    }
    const s = t(), { store: l, subscription: c, getServerState: f } = s, u = re.useRef(!0), h = re.useCallback(
      {
        [n.name](E) {
          const p = n(E);
          if (process.env.NODE_ENV !== "production") {
            const { devModeChecks: _ = {} } = typeof i == "function" ? {} : i, { identityFunctionCheck: R, stabilityCheck: C } = s, {
              identityFunctionCheck: v,
              stabilityCheck: b
            } = {
              stabilityCheck: C,
              identityFunctionCheck: R,
              ..._
            };
            if (b === "always" || b === "once" && u.current) {
              const g = n(E);
              if (!a(p, g)) {
                let y;
                try {
                  throw new Error();
                } catch (k) {
                  ({ stack: y } = k);
                }
                console.warn(
                  "Selector " + (n.name || "unknown") + ` returned a different result when called with the same parameters. This can lead to unnecessary rerenders.
Selectors that return a new reference (such as an object or an array) should be memoized: https://redux.js.org/usage/deriving-data-selectors#optimizing-selectors-with-memoization`,
                  {
                    state: E,
                    selected: p,
                    selected2: g,
                    stack: y
                  }
                );
              }
            }
            if ((v === "always" || v === "once" && u.current) && p === E) {
              let g;
              try {
                throw new Error();
              } catch (y) {
                ({ stack: g } = y);
              }
              console.warn(
                "Selector " + (n.name || "unknown") + ` returned the root state when called. This can lead to unnecessary rerenders.
Selectors that return the entire state are almost certainly a mistake, as they will cause a rerender whenever *anything* in state changes.`,
                { stack: g }
              );
            }
            u.current && (u.current = !1);
          }
          return p;
        }
      }[n.name],
      [n]
    ), w = So.useSyncExternalStoreWithSelector(
      c.addNestedSub,
      l.getState,
      f || l.getState,
      h,
      a
    );
    return re.useDebugValue(w), w;
  };
  return Object.assign(r, {
    withTypes: () => r
  }), r;
}
var vt = /* @__PURE__ */ Mo(), pt = () => Math.random().toString(36).substring(7).split("").join(".");
`${pt()}`, `${pt()}`;
function Do(e) {
  if (typeof e != "object" || e === null)
    return !1;
  let t = e;
  for (; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(e) === t || Object.getPrototypeOf(e) === null;
}
function Po(e) {
  return Do(e) && "type" in e && typeof e.type == "string";
}
var Pr = Symbol.for("immer-nothing"), cr = Symbol.for("immer-draftable"), U = Symbol.for("immer-state"), Io = process.env.NODE_ENV !== "production" ? [
  // All error codes, starting by 0:
  function(e) {
    return `The plugin for '${e}' has not been loaded into Immer. To enable the plugin, import and call \`enable${e}()\` when initializing your application.`;
  },
  function(e) {
    return `produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '${e}'`;
  },
  "This object has been frozen and should not be mutated",
  function(e) {
    return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + e;
  },
  "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
  "Immer forbids circular references",
  "The first or second argument to `produce` must be a function",
  "The third argument to `produce` must be a function or undefined",
  "First argument to `createDraft` must be a plain object, an array, or an immerable object",
  "First argument to `finishDraft` must be a draft returned by `createDraft`",
  function(e) {
    return `'current' expects a draft, got: ${e}`;
  },
  "Object.defineProperty() cannot be used on an Immer draft",
  "Object.setPrototypeOf() cannot be used on an Immer draft",
  "Immer only supports deleting array indices",
  "Immer only supports setting array indices and the 'length' property",
  function(e) {
    return `'original' expects a draft, got: ${e}`;
  }
  // Note: if more errors are added, the errorOffset in Patches.ts should be increased
  // See Patches.ts for additional errors
] : [];
function G(e, ...t) {
  if (process.env.NODE_ENV !== "production") {
    const r = Io[e], n = typeof r == "function" ? r.apply(null, t) : r;
    throw new Error(`[Immer] ${n}`);
  }
  throw new Error(
    `[Immer] minified error nr: ${e}. Full error at: https://bit.ly/3cXEKWf`
  );
}
var we = Object.getPrototypeOf;
function ue(e) {
  return !!e && !!e[U];
}
function Q(e) {
  return e ? Ir(e) || Array.isArray(e) || !!e[cr] || !!e.constructor?.[cr] || Oe(e) || qe(e) : !1;
}
var Ao = Object.prototype.constructor.toString(), lr = /* @__PURE__ */ new WeakMap();
function Ir(e) {
  if (!e || typeof e != "object")
    return !1;
  const t = Object.getPrototypeOf(e);
  if (t === null || t === Object.prototype)
    return !0;
  const r = Object.hasOwnProperty.call(t, "constructor") && t.constructor;
  if (r === Object)
    return !0;
  if (typeof r != "function")
    return !1;
  let n = lr.get(r);
  return n === void 0 && (n = Function.toString.call(r), lr.set(r, n)), n === Ao;
}
function He(e, t, r = !0) {
  Je(e) === 0 ? (r ? Reflect.ownKeys(e) : Object.keys(e)).forEach((i) => {
    t(i, e[i], e);
  }) : e.forEach((n, i) => t(i, n, e));
}
function Je(e) {
  const t = e[U];
  return t ? t.type_ : Array.isArray(e) ? 1 : Oe(e) ? 2 : qe(e) ? 3 : 0;
}
function Et(e, t) {
  return Je(e) === 2 ? e.has(t) : Object.prototype.hasOwnProperty.call(e, t);
}
function Ar(e, t, r) {
  const n = Je(e);
  n === 2 ? e.set(t, r) : n === 3 ? e.add(r) : e[t] = r;
}
function No(e, t) {
  return e === t ? e !== 0 || 1 / e === 1 / t : e !== e && t !== t;
}
function Oe(e) {
  return e instanceof Map;
}
function qe(e) {
  return e instanceof Set;
}
function se(e) {
  return e.copy_ || e.base_;
}
function _t(e, t) {
  if (Oe(e))
    return new Map(e);
  if (qe(e))
    return new Set(e);
  if (Array.isArray(e))
    return Array.prototype.slice.call(e);
  const r = Ir(e);
  if (t === !0 || t === "class_only" && !r) {
    const n = Object.getOwnPropertyDescriptors(e);
    delete n[U];
    let i = Reflect.ownKeys(n);
    for (let a = 0; a < i.length; a++) {
      const s = i[a], l = n[s];
      l.writable === !1 && (l.writable = !0, l.configurable = !0), (l.get || l.set) && (n[s] = {
        configurable: !0,
        writable: !0,
        // could live with !!desc.set as well here...
        enumerable: l.enumerable,
        value: e[s]
      });
    }
    return Object.create(we(e), n);
  } else {
    const n = we(e);
    if (n !== null && r)
      return { ...e };
    const i = Object.create(n);
    return Object.assign(i, e);
  }
}
function Pt(e, t = !1) {
  return Xe(e) || ue(e) || !Q(e) || (Je(e) > 1 && Object.defineProperties(e, {
    set: Ae,
    add: Ae,
    clear: Ae,
    delete: Ae
  }), Object.freeze(e), t && Object.values(e).forEach((r) => Pt(r, !0))), e;
}
function jo() {
  G(2);
}
var Ae = {
  value: jo
};
function Xe(e) {
  return e === null || typeof e != "object" ? !0 : Object.isFrozen(e);
}
var Lo = {};
function de(e) {
  const t = Lo[e];
  return t || G(0, e), t;
}
var ke;
function Nr() {
  return ke;
}
function Vo(e, t) {
  return {
    drafts_: [],
    parent_: e,
    immer_: t,
    // Whenever the modified draft contains a draft from another scope, we
    // need to prevent auto-freezing so the unowned draft can be finalized.
    canAutoFreeze_: !0,
    unfinalizedDrafts_: 0
  };
}
function ur(e, t) {
  t && (de("Patches"), e.patches_ = [], e.inversePatches_ = [], e.patchListener_ = t);
}
function wt(e) {
  kt(e), e.drafts_.forEach(Fo), e.drafts_ = null;
}
function kt(e) {
  e === ke && (ke = e.parent_);
}
function dr(e) {
  return ke = Vo(ke, e);
}
function Fo(e) {
  const t = e[U];
  t.type_ === 0 || t.type_ === 1 ? t.revoke_() : t.revoked_ = !0;
}
function fr(e, t) {
  t.unfinalizedDrafts_ = t.drafts_.length;
  const r = t.drafts_[0];
  return e !== void 0 && e !== r ? (r[U].modified_ && (wt(t), G(4)), Q(e) && (e = Be(t, e), t.parent_ || We(t, e)), t.patches_ && de("Patches").generateReplacementPatches_(
    r[U].base_,
    e,
    t.patches_,
    t.inversePatches_
  )) : e = Be(t, r, []), wt(t), t.patches_ && t.patchListener_(t.patches_, t.inversePatches_), e !== Pr ? e : void 0;
}
function Be(e, t, r) {
  if (Xe(t))
    return t;
  const n = e.immer_.shouldUseStrictIteration(), i = t[U];
  if (!i)
    return He(
      t,
      (a, s) => pr(e, i, t, a, s, r),
      n
    ), t;
  if (i.scope_ !== e)
    return t;
  if (!i.modified_)
    return We(e, i.base_, !0), i.base_;
  if (!i.finalized_) {
    i.finalized_ = !0, i.scope_.unfinalizedDrafts_--;
    const a = i.copy_;
    let s = a, l = !1;
    i.type_ === 3 && (s = new Set(a), a.clear(), l = !0), He(
      s,
      (c, f) => pr(
        e,
        i,
        a,
        c,
        f,
        r,
        l
      ),
      n
    ), We(e, a, !1), r && e.patches_ && de("Patches").generatePatches_(
      i,
      r,
      e.patches_,
      e.inversePatches_
    );
  }
  return i.copy_;
}
function pr(e, t, r, n, i, a, s) {
  if (i == null || typeof i != "object" && !s)
    return;
  const l = Xe(i);
  if (!(l && !s)) {
    if (process.env.NODE_ENV !== "production" && i === r && G(5), ue(i)) {
      const c = a && t && t.type_ !== 3 && // Set objects are atomic since they have no keys.
      !Et(t.assigned_, n) ? a.concat(n) : void 0, f = Be(e, i, c);
      if (Ar(r, n, f), ue(f))
        e.canAutoFreeze_ = !1;
      else
        return;
    } else
      s && r.add(i);
    if (Q(i) && !l) {
      if (!e.immer_.autoFreeze_ && e.unfinalizedDrafts_ < 1 || t && t.base_ && t.base_[n] === i && l)
        return;
      Be(e, i), (!t || !t.scope_.parent_) && typeof n != "symbol" && (Oe(r) ? r.has(n) : Object.prototype.propertyIsEnumerable.call(r, n)) && We(e, i);
    }
  }
}
function We(e, t, r = !1) {
  !e.parent_ && e.immer_.autoFreeze_ && e.canAutoFreeze_ && Pt(t, r);
}
function zo(e, t) {
  const r = Array.isArray(e), n = {
    type_: r ? 1 : 0,
    // Track which produce call this is associated with.
    scope_: t ? t.scope_ : Nr(),
    // True for both shallow and deep changes.
    modified_: !1,
    // Used during finalization.
    finalized_: !1,
    // Track which properties have been assigned (true) or deleted (false).
    assigned_: {},
    // The parent draft state.
    parent_: t,
    // The base state.
    base_: e,
    // The base proxy.
    draft_: null,
    // set below
    // The base copy with any updated values.
    copy_: null,
    // Called by the `produce` function.
    revoke_: null,
    isManual_: !1
  };
  let i = n, a = It;
  r && (i = [n], a = Se);
  const { revoke: s, proxy: l } = Proxy.revocable(i, a);
  return n.draft_ = l, n.revoke_ = s, l;
}
var It = {
  get(e, t) {
    if (t === U)
      return e;
    const r = se(e);
    if (!Et(r, t))
      return Go(e, r, t);
    const n = r[t];
    return e.finalized_ || !Q(n) ? n : n === mt(e.base_, t) ? (yt(e), e.copy_[t] = Rt(n, e)) : n;
  },
  has(e, t) {
    return t in se(e);
  },
  ownKeys(e) {
    return Reflect.ownKeys(se(e));
  },
  set(e, t, r) {
    const n = jr(se(e), t);
    if (n?.set)
      return n.set.call(e.draft_, r), !0;
    if (!e.modified_) {
      const i = mt(se(e), t), a = i?.[U];
      if (a && a.base_ === r)
        return e.copy_[t] = r, e.assigned_[t] = !1, !0;
      if (No(r, i) && (r !== void 0 || Et(e.base_, t)))
        return !0;
      yt(e), St(e);
    }
    return e.copy_[t] === r && // special case: handle new props with value 'undefined'
    (r !== void 0 || t in e.copy_) || // special case: NaN
    Number.isNaN(r) && Number.isNaN(e.copy_[t]) || (e.copy_[t] = r, e.assigned_[t] = !0), !0;
  },
  deleteProperty(e, t) {
    return mt(e.base_, t) !== void 0 || t in e.base_ ? (e.assigned_[t] = !1, yt(e), St(e)) : delete e.assigned_[t], e.copy_ && delete e.copy_[t], !0;
  },
  // Note: We never coerce `desc.value` into an Immer draft, because we can't make
  // the same guarantee in ES5 mode.
  getOwnPropertyDescriptor(e, t) {
    const r = se(e), n = Reflect.getOwnPropertyDescriptor(r, t);
    return n && {
      writable: !0,
      configurable: e.type_ !== 1 || t !== "length",
      enumerable: n.enumerable,
      value: r[t]
    };
  },
  defineProperty() {
    G(11);
  },
  getPrototypeOf(e) {
    return we(e.base_);
  },
  setPrototypeOf() {
    G(12);
  }
}, Se = {};
He(It, (e, t) => {
  Se[e] = function() {
    return arguments[0] = arguments[0][0], t.apply(this, arguments);
  };
});
Se.deleteProperty = function(e, t) {
  return process.env.NODE_ENV !== "production" && isNaN(parseInt(t)) && G(13), Se.set.call(this, e, t, void 0);
};
Se.set = function(e, t, r) {
  return process.env.NODE_ENV !== "production" && t !== "length" && isNaN(parseInt(t)) && G(14), It.set.call(this, e[0], t, r, e[0]);
};
function mt(e, t) {
  const r = e[U];
  return (r ? se(r) : e)[t];
}
function Go(e, t, r) {
  const n = jr(t, r);
  return n ? "value" in n ? n.value : (
    // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    n.get?.call(e.draft_)
  ) : void 0;
}
function jr(e, t) {
  if (!(t in e))
    return;
  let r = we(e);
  for (; r; ) {
    const n = Object.getOwnPropertyDescriptor(r, t);
    if (n)
      return n;
    r = we(r);
  }
}
function St(e) {
  e.modified_ || (e.modified_ = !0, e.parent_ && St(e.parent_));
}
function yt(e) {
  e.copy_ || (e.copy_ = _t(
    e.base_,
    e.scope_.immer_.useStrictShallowCopy_
  ));
}
var $o = class {
  constructor(e) {
    this.autoFreeze_ = !0, this.useStrictShallowCopy_ = !1, this.useStrictIteration_ = !0, this.produce = (t, r, n) => {
      if (typeof t == "function" && typeof r != "function") {
        const a = r;
        r = t;
        const s = this;
        return function(c = a, ...f) {
          return s.produce(c, (u) => r.call(this, u, ...f));
        };
      }
      typeof r != "function" && G(6), n !== void 0 && typeof n != "function" && G(7);
      let i;
      if (Q(t)) {
        const a = dr(this), s = Rt(t, void 0);
        let l = !0;
        try {
          i = r(s), l = !1;
        } finally {
          l ? wt(a) : kt(a);
        }
        return ur(a, n), fr(i, a);
      } else if (!t || typeof t != "object") {
        if (i = r(t), i === void 0 && (i = t), i === Pr && (i = void 0), this.autoFreeze_ && Pt(i, !0), n) {
          const a = [], s = [];
          de("Patches").generateReplacementPatches_(t, i, a, s), n(a, s);
        }
        return i;
      } else
        G(1, t);
    }, this.produceWithPatches = (t, r) => {
      if (typeof t == "function")
        return (s, ...l) => this.produceWithPatches(s, (c) => t(c, ...l));
      let n, i;
      return [this.produce(t, r, (s, l) => {
        n = s, i = l;
      }), n, i];
    }, typeof e?.autoFreeze == "boolean" && this.setAutoFreeze(e.autoFreeze), typeof e?.useStrictShallowCopy == "boolean" && this.setUseStrictShallowCopy(e.useStrictShallowCopy), typeof e?.useStrictIteration == "boolean" && this.setUseStrictIteration(e.useStrictIteration);
  }
  createDraft(e) {
    Q(e) || G(8), ue(e) && (e = Lr(e));
    const t = dr(this), r = Rt(e, void 0);
    return r[U].isManual_ = !0, kt(t), r;
  }
  finishDraft(e, t) {
    const r = e && e[U];
    (!r || !r.isManual_) && G(9);
    const { scope_: n } = r;
    return ur(n, t), fr(void 0, n);
  }
  /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */
  setAutoFreeze(e) {
    this.autoFreeze_ = e;
  }
  /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */
  setUseStrictShallowCopy(e) {
    this.useStrictShallowCopy_ = e;
  }
  /**
   * Pass false to use faster iteration that skips non-enumerable properties
   * but still handles symbols for compatibility.
   *
   * By default, strict iteration is enabled (includes all own properties).
   */
  setUseStrictIteration(e) {
    this.useStrictIteration_ = e;
  }
  shouldUseStrictIteration() {
    return this.useStrictIteration_;
  }
  applyPatches(e, t) {
    let r;
    for (r = t.length - 1; r >= 0; r--) {
      const i = t[r];
      if (i.path.length === 0 && i.op === "replace") {
        e = i.value;
        break;
      }
    }
    r > -1 && (t = t.slice(r + 1));
    const n = de("Patches").applyPatches_;
    return ue(e) ? n(e, t) : this.produce(
      e,
      (i) => n(i, t)
    );
  }
};
function Rt(e, t) {
  const r = Oe(e) ? de("MapSet").proxyMap_(e, t) : qe(e) ? de("MapSet").proxySet_(e, t) : zo(e, t);
  return (t ? t.scope_ : Nr()).drafts_.push(r), r;
}
function Lr(e) {
  return ue(e) || G(10, e), Vr(e);
}
function Vr(e) {
  if (!Q(e) || Xe(e))
    return e;
  const t = e[U];
  let r, n = !0;
  if (t) {
    if (!t.modified_)
      return t.base_;
    t.finalized_ = !0, r = _t(e, t.scope_.immer_.useStrictShallowCopy_), n = t.scope_.immer_.shouldUseStrictIteration();
  } else
    r = _t(e, !0);
  return He(
    r,
    (i, a) => {
      Ar(r, i, Vr(a));
    },
    n
  ), t && (t.finalized_ = !1), r;
}
var Ct = new $o(), Fr = Ct.produce, Uo = /* @__PURE__ */ Ct.setUseStrictIteration.bind(
  Ct
), Ho = (e, t, r) => {
  if (t.length === 1 && t[0] === r) {
    let n = !1;
    try {
      const i = {};
      e(i) === i && (n = !0);
    } catch {
    }
    if (n) {
      let i;
      try {
        throw new Error();
      } catch (a) {
        ({ stack: i } = a);
      }
      console.warn(
        `The result function returned its own inputs without modification. e.g
\`createSelector([state => state.todos], todos => todos)\`
This could lead to inefficient memoization and unnecessary re-renders.
Ensure transformation logic is in the result function, and extraction logic is in the input selectors.`,
        { stack: i }
      );
    }
  }
}, Bo = (e, t, r) => {
  const { memoize: n, memoizeOptions: i } = t, { inputSelectorResults: a, inputSelectorResultsCopy: s } = e, l = n(() => ({}), ...i);
  if (!(l.apply(null, a) === l.apply(null, s))) {
    let f;
    try {
      throw new Error();
    } catch (u) {
      ({ stack: f } = u);
    }
    console.warn(
      `An input selector returned a different result when passed same arguments.
This means your output selector will likely run more frequently than intended.
Avoid returning a new reference inside your input selector, e.g.
\`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)\``,
      {
        arguments: r,
        firstInputs: a,
        secondInputs: s,
        stack: f
      }
    );
  }
}, Wo = {
  inputStabilityCheck: "once",
  identityFunctionCheck: "once"
};
function Ko(e, t = `expected a function, instead received ${typeof e}`) {
  if (typeof e != "function")
    throw new TypeError(t);
}
function Yo(e, t = `expected an object, instead received ${typeof e}`) {
  if (typeof e != "object")
    throw new TypeError(t);
}
function Jo(e, t = "expected all items to be functions, instead received the following types: ") {
  if (!e.every((r) => typeof r == "function")) {
    const r = e.map(
      (n) => typeof n == "function" ? `function ${n.name || "unnamed"}()` : typeof n
    ).join(", ");
    throw new TypeError(`${t}[${r}]`);
  }
}
var mr = (e) => Array.isArray(e) ? e : [e];
function qo(e) {
  const t = Array.isArray(e[0]) ? e[0] : e;
  return Jo(
    t,
    "createSelector expects all input-selectors to be functions, but received the following types: "
  ), t;
}
function yr(e, t) {
  const r = [], { length: n } = e;
  for (let i = 0; i < n; i++)
    r.push(e[i].apply(null, t));
  return r;
}
var Xo = (e, t) => {
  const { identityFunctionCheck: r, inputStabilityCheck: n } = {
    ...Wo,
    ...t
  };
  return {
    identityFunctionCheck: {
      shouldRun: r === "always" || r === "once" && e,
      run: Ho
    },
    inputStabilityCheck: {
      shouldRun: n === "always" || n === "once" && e,
      run: Bo
    }
  };
}, Qo = class {
  constructor(e) {
    this.value = e;
  }
  deref() {
    return this.value;
  }
}, Zo = typeof WeakRef < "u" ? WeakRef : Qo, ei = 0, hr = 1;
function Ne() {
  return {
    s: ei,
    v: void 0,
    o: null,
    p: null
  };
}
function zr(e, t = {}) {
  let r = Ne();
  const { resultEqualityCheck: n } = t;
  let i, a = 0;
  function s() {
    let l = r;
    const { length: c } = arguments;
    for (let h = 0, w = c; h < w; h++) {
      const E = arguments[h];
      if (typeof E == "function" || typeof E == "object" && E !== null) {
        let p = l.o;
        p === null && (l.o = p = /* @__PURE__ */ new WeakMap());
        const _ = p.get(E);
        _ === void 0 ? (l = Ne(), p.set(E, l)) : l = _;
      } else {
        let p = l.p;
        p === null && (l.p = p = /* @__PURE__ */ new Map());
        const _ = p.get(E);
        _ === void 0 ? (l = Ne(), p.set(E, l)) : l = _;
      }
    }
    const f = l;
    let u;
    if (l.s === hr)
      u = l.v;
    else if (u = e.apply(null, arguments), a++, n) {
      const h = i?.deref?.() ?? i;
      h != null && n(h, u) && (u = h, a !== 0 && a--), i = typeof u == "object" && u !== null || typeof u == "function" ? new Zo(u) : u;
    }
    return f.s = hr, f.v = u, u;
  }
  return s.clearCache = () => {
    r = Ne(), s.resetResultsCount();
  }, s.resultsCount = () => a, s.resetResultsCount = () => {
    a = 0;
  }, s;
}
function ti(e, ...t) {
  const r = typeof e == "function" ? {
    memoize: e,
    memoizeOptions: t
  } : e, n = (...i) => {
    let a = 0, s = 0, l, c = {}, f = i.pop();
    typeof f == "object" && (c = f, f = i.pop()), Ko(
      f,
      `createSelector expects an output function after the inputs, but received: [${typeof f}]`
    );
    const u = {
      ...r,
      ...c
    }, {
      memoize: h,
      memoizeOptions: w = [],
      argsMemoize: E = zr,
      argsMemoizeOptions: p = [],
      devModeChecks: _ = {}
    } = u, R = mr(w), C = mr(p), v = qo(i), b = h(function() {
      return a++, f.apply(
        null,
        arguments
      );
    }, ...R);
    let g = !0;
    const y = E(function() {
      s++;
      const M = yr(
        v,
        arguments
      );
      if (l = b.apply(null, M), process.env.NODE_ENV !== "production") {
        const { identityFunctionCheck: P, inputStabilityCheck: $ } = Xo(g, _);
        if (P.shouldRun && P.run(
          f,
          M,
          l
        ), $.shouldRun) {
          const K = yr(
            v,
            arguments
          );
          $.run(
            { inputSelectorResults: M, inputSelectorResultsCopy: K },
            { memoize: h, memoizeOptions: R },
            arguments
          );
        }
        g && (g = !1);
      }
      return l;
    }, ...C);
    return Object.assign(y, {
      resultFunc: f,
      memoizedResultFunc: b,
      dependencies: v,
      dependencyRecomputations: () => s,
      resetDependencyRecomputations: () => {
        s = 0;
      },
      lastResult: () => l,
      recomputations: () => a,
      resetRecomputations: () => {
        a = 0;
      },
      memoize: h,
      argsMemoize: E
    });
  };
  return Object.assign(n, {
    withTypes: () => n
  }), n;
}
var At = /* @__PURE__ */ ti(zr), ri = Object.assign(
  (e, t = At) => {
    Yo(
      e,
      `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof e}`
    );
    const r = Object.keys(e), n = r.map(
      (a) => e[a]
    );
    return t(
      n,
      (...a) => a.reduce((s, l, c) => (s[r[c]] = l, s), {})
    );
  },
  { withTypes: () => ri }
);
function gr(e, t) {
  function r(...n) {
    if (t) {
      let i = t(...n);
      if (!i)
        throw new Error(process.env.NODE_ENV === "production" ? L(0) : "prepareAction did not return an object");
      return {
        type: e,
        payload: i.payload,
        ..."meta" in i && {
          meta: i.meta
        },
        ..."error" in i && {
          error: i.error
        }
      };
    }
    return {
      type: e,
      payload: n[0]
    };
  }
  return r.toString = () => `${e}`, r.type = e, r.match = (n) => Po(n) && n.type === e, r;
}
function br(e) {
  return Q(e) ? Fr(e, () => {
  }) : e;
}
function je(e, t, r) {
  return e.has(t) ? e.get(t) : e.set(t, r(t)).get(t);
}
function Gr(e) {
  const t = {}, r = [];
  let n;
  const i = {
    addCase(a, s) {
      if (process.env.NODE_ENV !== "production") {
        if (r.length > 0)
          throw new Error(process.env.NODE_ENV === "production" ? L(26) : "`builder.addCase` should only be called before calling `builder.addMatcher`");
        if (n)
          throw new Error(process.env.NODE_ENV === "production" ? L(27) : "`builder.addCase` should only be called before calling `builder.addDefaultCase`");
      }
      const l = typeof a == "string" ? a : a.type;
      if (!l)
        throw new Error(process.env.NODE_ENV === "production" ? L(28) : "`builder.addCase` cannot be called with an empty action type");
      if (l in t)
        throw new Error(process.env.NODE_ENV === "production" ? L(29) : `\`builder.addCase\` cannot be called with two reducers for the same action type '${l}'`);
      return t[l] = s, i;
    },
    addAsyncThunk(a, s) {
      if (process.env.NODE_ENV !== "production" && n)
        throw new Error(process.env.NODE_ENV === "production" ? L(43) : "`builder.addAsyncThunk` should only be called before calling `builder.addDefaultCase`");
      return s.pending && (t[a.pending.type] = s.pending), s.rejected && (t[a.rejected.type] = s.rejected), s.fulfilled && (t[a.fulfilled.type] = s.fulfilled), s.settled && r.push({
        matcher: a.settled,
        reducer: s.settled
      }), i;
    },
    addMatcher(a, s) {
      if (process.env.NODE_ENV !== "production" && n)
        throw new Error(process.env.NODE_ENV === "production" ? L(30) : "`builder.addMatcher` should only be called before calling `builder.addDefaultCase`");
      return r.push({
        matcher: a,
        reducer: s
      }), i;
    },
    addDefaultCase(a) {
      if (process.env.NODE_ENV !== "production" && n)
        throw new Error(process.env.NODE_ENV === "production" ? L(31) : "`builder.addDefaultCase` can only be called once");
      return n = a, i;
    }
  };
  return e(i), [t, r, n];
}
Uo(!1);
function ni(e) {
  return typeof e == "function";
}
function oi(e, t) {
  if (process.env.NODE_ENV !== "production" && typeof t == "object")
    throw new Error(process.env.NODE_ENV === "production" ? L(8) : "The object notation for `createReducer` has been removed. Please use the 'builder callback' notation instead: https://redux-toolkit.js.org/api/createReducer");
  let [r, n, i] = Gr(t), a;
  if (ni(e))
    a = () => br(e());
  else {
    const l = br(e);
    a = () => l;
  }
  function s(l = a(), c) {
    let f = [r[c.type], ...n.filter(({
      matcher: u
    }) => u(c)).map(({
      reducer: u
    }) => u)];
    return f.filter((u) => !!u).length === 0 && (f = [i]), f.reduce((u, h) => {
      if (h)
        if (ue(u)) {
          const E = h(u, c);
          return E === void 0 ? u : E;
        } else {
          if (Q(u))
            return Fr(u, (w) => h(w, c));
          {
            const w = h(u, c);
            if (w === void 0) {
              if (u === null)
                return u;
              throw Error("A case reducer on a non-draftable value must not return undefined");
            }
            return w;
          }
        }
      return u;
    }, l);
  }
  return s.getInitialState = a, s;
}
var ii = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
function ai(e, t) {
  return `${e}/${t}`;
}
function si({
  creators: e
} = {}) {
  const t = e?.asyncThunk?.[ii];
  return function(n) {
    const {
      name: i,
      reducerPath: a = i
    } = n;
    if (!i)
      throw new Error(process.env.NODE_ENV === "production" ? L(11) : "`name` is a required option for createSlice");
    typeof process < "u" && process.env.NODE_ENV === "development" && n.initialState === void 0 && console.error("You must provide an `initialState` value that is not `undefined`. You may have misspelled `initialState`");
    const s = (typeof n.reducers == "function" ? n.reducers(ui()) : n.reducers) || {}, l = Object.keys(s), c = {
      sliceCaseReducersByName: {},
      sliceCaseReducersByType: {},
      actionCreators: {},
      sliceMatchers: []
    }, f = {
      addCase(b, g) {
        const y = typeof b == "string" ? b : b.type;
        if (!y)
          throw new Error(process.env.NODE_ENV === "production" ? L(12) : "`context.addCase` cannot be called with an empty action type");
        if (y in c.sliceCaseReducersByType)
          throw new Error(process.env.NODE_ENV === "production" ? L(13) : "`context.addCase` cannot be called with two reducers for the same action type: " + y);
        return c.sliceCaseReducersByType[y] = g, f;
      },
      addMatcher(b, g) {
        return c.sliceMatchers.push({
          matcher: b,
          reducer: g
        }), f;
      },
      exposeAction(b, g) {
        return c.actionCreators[b] = g, f;
      },
      exposeCaseReducer(b, g) {
        return c.sliceCaseReducersByName[b] = g, f;
      }
    };
    l.forEach((b) => {
      const g = s[b], y = {
        reducerName: b,
        type: ai(i, b),
        createNotation: typeof n.reducers == "function"
      };
      fi(g) ? mi(y, g, f, t) : di(y, g, f);
    });
    function u() {
      if (process.env.NODE_ENV !== "production" && typeof n.extraReducers == "object")
        throw new Error(process.env.NODE_ENV === "production" ? L(14) : "The object notation for `createSlice.extraReducers` has been removed. Please use the 'builder callback' notation instead: https://redux-toolkit.js.org/api/createSlice");
      const [b = {}, g = [], y = void 0] = typeof n.extraReducers == "function" ? Gr(n.extraReducers) : [n.extraReducers], k = {
        ...b,
        ...c.sliceCaseReducersByType
      };
      return oi(n.initialState, (M) => {
        for (let P in k)
          M.addCase(P, k[P]);
        for (let P of c.sliceMatchers)
          M.addMatcher(P.matcher, P.reducer);
        for (let P of g)
          M.addMatcher(P.matcher, P.reducer);
        y && M.addDefaultCase(y);
      });
    }
    const h = (b) => b, w = /* @__PURE__ */ new Map(), E = /* @__PURE__ */ new WeakMap();
    let p;
    function _(b, g) {
      return p || (p = u()), p(b, g);
    }
    function R() {
      return p || (p = u()), p.getInitialState();
    }
    function C(b, g = !1) {
      function y(M) {
        let P = M[b];
        if (typeof P > "u") {
          if (g)
            P = je(E, y, R);
          else if (process.env.NODE_ENV !== "production")
            throw new Error(process.env.NODE_ENV === "production" ? L(15) : "selectSlice returned undefined for an uninjected slice reducer");
        }
        return P;
      }
      function k(M = h) {
        const P = je(w, g, () => /* @__PURE__ */ new WeakMap());
        return je(P, M, () => {
          const $ = {};
          for (const [K, H] of Object.entries(n.selectors ?? {}))
            $[K] = ci(H, M, () => je(E, M, R), g);
          return $;
        });
      }
      return {
        reducerPath: b,
        getSelectors: k,
        get selectors() {
          return k(y);
        },
        selectSlice: y
      };
    }
    const v = {
      name: i,
      reducer: _,
      actions: c.actionCreators,
      caseReducers: c.sliceCaseReducersByName,
      getInitialState: R,
      ...C(a),
      injectInto(b, {
        reducerPath: g,
        ...y
      } = {}) {
        const k = g ?? a;
        return b.inject({
          reducerPath: k,
          reducer: _
        }, y), {
          ...v,
          ...C(k, !0)
        };
      }
    };
    return v;
  };
}
function ci(e, t, r, n) {
  function i(a, ...s) {
    let l = t(a);
    if (typeof l > "u") {
      if (n)
        l = r();
      else if (process.env.NODE_ENV !== "production")
        throw new Error(process.env.NODE_ENV === "production" ? L(16) : "selectState returned undefined for an uninjected slice reducer");
    }
    return e(l, ...s);
  }
  return i.unwrapped = e, i;
}
var li = /* @__PURE__ */ si();
function ui() {
  function e(t, r) {
    return {
      _reducerDefinitionType: "asyncThunk",
      payloadCreator: t,
      ...r
    };
  }
  return e.withTypes = () => e, {
    reducer(t) {
      return Object.assign({
        // hack so the wrapping function has the same name as the original
        // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
        [t.name](...r) {
          return t(...r);
        }
      }[t.name], {
        _reducerDefinitionType: "reducer"
        /* reducer */
      });
    },
    preparedReducer(t, r) {
      return {
        _reducerDefinitionType: "reducerWithPrepare",
        prepare: t,
        reducer: r
      };
    },
    asyncThunk: e
  };
}
function di({
  type: e,
  reducerName: t,
  createNotation: r
}, n, i) {
  let a, s;
  if ("reducer" in n) {
    if (r && !pi(n))
      throw new Error(process.env.NODE_ENV === "production" ? L(17) : "Please use the `create.preparedReducer` notation for prepared action creators with the `create` notation.");
    a = n.reducer, s = n.prepare;
  } else
    a = n;
  i.addCase(e, a).exposeCaseReducer(t, a).exposeAction(t, s ? gr(e, s) : gr(e));
}
function fi(e) {
  return e._reducerDefinitionType === "asyncThunk";
}
function pi(e) {
  return e._reducerDefinitionType === "reducerWithPrepare";
}
function mi({
  type: e,
  reducerName: t
}, r, n, i) {
  if (!i)
    throw new Error(process.env.NODE_ENV === "production" ? L(18) : "Cannot use `create.asyncThunk` in the built-in `createSlice`. Use `buildCreateSlice({ creators: { asyncThunk: asyncThunkCreator } })` to create a customised version of `createSlice`.");
  const {
    payloadCreator: a,
    fulfilled: s,
    pending: l,
    rejected: c,
    settled: f,
    options: u
  } = r, h = i(e, a, u);
  n.exposeAction(t, h), s && n.addCase(h.fulfilled, s), l && n.addCase(h.pending, l), c && n.addCase(h.rejected, c), f && n.addMatcher(h.settled, f), n.exposeCaseReducer(t, {
    fulfilled: s || Le,
    pending: l || Le,
    rejected: c || Le,
    settled: f || Le
  });
}
function Le() {
}
function L(e) {
  return `Minified Redux Toolkit error #${e}; visit https://redux-toolkit.js.org/Errors?code=${e} for the full message or use the non-minified dev environment for full errors. `;
}
const yi = {
  mode: "2d",
  extent: void 0,
  zoom: void 0,
  scale: void 0,
  selectedPoint: null,
  locationHistory: [],
  highlightGeometries: null,
  disableMapClick: !1,
  selectedLocation: null
}, $r = li({
  name: "map",
  initialState: yi,
  reducers: {
    setMapMode(e, t) {
      e.mode = t.payload;
    },
    toggleMapMode(e) {
      e.mode = e.mode === "2d" ? "3d" : "2d";
    },
    setExtent(e, t) {
      const r = Lr(e).extent;
      (!r || Math.abs(r.xmin - (t.payload.extent?.xmin || 0)) > 1 || Math.abs(r.ymin - (t.payload.extent?.ymin || 0)) > 1 || Math.abs(r.xmax - (t.payload.extent?.xmax || 0)) > 1 || Math.abs(r.ymax - (t.payload.extent?.ymax || 0)) > 1) && (e.extent = t.payload.extent, e.zoom = t.payload.zoom, e.scale = t.payload.scale);
    },
    setSelectedPoint(e, t) {
      e.selectedPoint = t.payload;
    },
    addToLocationHistory(e, t) {
      t.payload.selected ? e.locationHistory.forEach((r) => r.selected = !1) : e.locationHistory.length === 0 && (t.payload.selected = !0), t.payload.id || (t.payload.id = crypto.randomUUID()), e.locationHistory.unshift(t.payload), e.locationHistory.length > 10 && e.locationHistory.pop(), e.selectedLocation = t.payload.selected ? t.payload : e.selectedLocation;
    },
    setLocationHistorySelected(e, t) {
      e.locationHistory.forEach((r) => {
        r.selected = r.id === t.payload, r.selected && (e.selectedLocation = r);
      });
    },
    setSelectedLocation(e, t) {
      if (t.payload) {
        e.locationHistory.forEach((n) => n.selected = !1);
        const r = e.locationHistory.find(
          (n) => n.x === t.payload.x && n.y === t.payload.y
        );
        r ? r.selected = !0 : (t.payload.id || (t.payload.id = crypto.randomUUID()), t.payload.selected = !0, e.locationHistory.unshift(t.payload), e.locationHistory.length > 10 && e.locationHistory.pop());
      }
      e.selectedLocation = t.payload;
    },
    setHighlightGeometries(e, t) {
      e.highlightGeometries = t.payload;
    },
    setDisableMapClick(e, t) {
      e.disableMapClick = t.payload;
    }
  }
}), {
  setMapMode: ns,
  toggleMapMode: os,
  setExtent: is,
  setSelectedPoint: as,
  addToLocationHistory: ss,
  setLocationHistorySelected: cs,
  setSelectedLocation: hi,
  setHighlightGeometries: ls,
  setDisableMapClick: gi
} = $r.actions, us = (e) => e.map.locationHistory, Ur = (e) => e.map.disableMapClick, bi = (e) => e.map.selectedLocation;
At(
  (e) => e.map.highlightGeometries,
  (e) => e ? {
    geometries: e.geometries?.map((r) => Cr.fromJSON(r))?.filter((r) => r !== void 0),
    symbol: e.symbol,
    zoomTo: e.zoomTo
  } : null
);
At(
  (e) => e.map.locationHistory,
  (e) => {
    const t = e?.filter((r) => r.selected);
    return t && t.length === 1 ? t[0] : null;
  }
);
$r.reducer;
const Hr = () => {
  const e = Oo(), t = vt(Ur), r = vt(bi), n = ne(
    (a) => e(gi(a)),
    [e]
  ), i = ne(
    (a) => e(hi(a)),
    [e]
  );
  return {
    disableMapClick: t,
    selectedLocation: r,
    setDisableMapClick: n,
    setSelectedLocation: i
  };
}, ds = () => vt(Ur);
new $n({
  url: "https://services.geodataonline.no/arcgis/rest/services/Geomap_UTM33_EUREF89/GeomapAdmin/MapServer",
  title: "Administrative enheter",
  visible: !1
});
const vi = new Ot({
  url: "https://services.geodataonline.no/arcgis/rest/services/Geomap_UTM33_EUREF89/GeomapGeoEiendom/MapServer/15",
  title: "Eiendomsgrenser",
  visible: !0,
  id: "Eiendomsgrenser"
}), Ei = () => new qn({
  data: {
    type: "CIMSymbolReference",
    symbol: {
      type: "CIMLineSymbol",
      symbolLayers: [{
        type: "CIMSolidStroke",
        enable: !0,
        width: 1,
        color: [255, 0, 0, 255],
        capStyle: "Butt",
        joinStyle: "Miter",
        effects: [{
          type: "CIMGeometricEffectDashes",
          dashTemplate: [4, 6],
          lineDashEnding: "NoConstraint"
        }]
      }]
    }
  }
}), _i = new Ot({
  url: "https://services.geodataonline.no/arcgis/rest/services/Geomap_UTM33_EUREF89/GeomapGeoEiendom/MapServer/9",
  title: "Spesielle grenser",
  visible: !0,
  id: "SpesielleGrenser",
  renderer: new Jn({
    field: "hjelpelinjetype",
    field2: "omtvistet",
    fieldDelimiter: ",",
    uniqueValueInfos: [
      ["IH - Ikke hjelpelinje,1", "Omtvistet grense"],
      ["FI - Fiktiv grense,1", "Omtvistet grense"],
      ["PF - Punktfeste,1", "Omtvistet grense"],
      ["TD - Teigdeler,1", "Omtvistet grense"],
      ["VA - Vannkant,1", "Omtvistet grense"],
      ["VE - Vegkant,1", "Omtvistet grense"],
      ["VA - Vannkant,0", "Hjelpelinje vannkant"],
      ["VE - Vegkant,0", "Hjelpelinje vegkant"],
      ["FI - Fiktiv grense,0", "Fiktive hjelpelinjer"],
      ["TD - Teigdeler,0", "Fiktive hjelpelinjer"],
      ["PF - Punktfeste,0", "Hjelpelinje punktfeste"]
    ].map(([e, t]) => ({ value: e, label: t, symbol: Ei() }))
  })
}), vr = new Ot({
  url: "https://services.geodataonline.no/arcgis/rest/services/Geomap_UTM33_EUREF89/GeomapGeoEiendom/MapServer/7",
  title: "Eiendommer",
  visible: !0,
  id: "Eiendommer",
  listMode: "hide",
  renderer: new Kn({
    symbol: new Yn({
      color: [0, 0, 0, 0],
      outline: { color: [0, 0, 0, 0], width: 0 }
    })
  })
});
new Bn({
  layers: [
    new Hn({
      url: "https://services.geodataonline.no/arcgis/rest/services/Geocache_UTM33_EUREF89/GeocacheTerreng/ImageServer"
    })
  ],
  navigationConstraint: { type: "stay-above" }
});
new Un({
  url: "https://services.geodataonline.no/arcgis/rest/services/Geoscene/GeosceneBygning2/SceneServer",
  minScale: 2e4,
  title: "Bygninger",
  popupEnabled: !1
});
const Br = new X({
  baseLayers: [
    new ce({
      url: "https://services.geodataonline.no/arcgis/rest/services/GeocacheVector/GeocacheBasisTerreng_UTM32/VectorTileServer"
    })
  ],
  id: "basis_terreng",
  thumbnailUrl: "images/basis terreng.png"
}), Wr = new X({
  baseLayers: [
    new ce({
      url: "https://services.geodataonline.no/arcgis/rest/services/GeocacheVector/GeocacheGraatoneTerreng_UTM32/VectorTileServer"
    })
  ],
  id: "graatone_terreng",
  thumbnailUrl: "images/gråtone terreng.png"
}), Kr = new X({
  baseLayers: [
    new ce({
      url: "https://services.geodataonline.no/arcgis/rest/services/GeocacheVector/GeocacheKanvasMork_UTM32/VectorTileServer"
    })
  ],
  id: "mork",
  thumbnailUrl: "images/kanvas mørk.png"
}), Yr = new X({
  baseLayers: [
    // Gir visningen et vektorbasert (i praksis ubegrenset) LOD-skjema, slik at
    // kartet ikke låses til flyfoto-tjenestens cachede maks-zoom (1:625).
    new ce({
      url: "https://services.geodataonline.no/arcgis/rest/services/GeocacheVector/GeocacheGraatoneTerreng_UTM32/VectorTileServer"
    }),
    new Or({
      url: "https://services.geodataonline.no/arcgis/rest/services/Geocache_UTM32_EUREF89/GeocacheBilder/MapServer"
    })
  ],
  id: "bilder",
  thumbnailUrl: "images/bilder.png"
}), Jr = new Wn({
  basemaps: [Br, Wr, Yr, Kr]
}), qr = "https://services.geodataonline.no/arcgis/rest/services", wi = {
  25833: { suffiks: "", bilder: "Geocache_UTM33_EUREF89", mork: !0 },
  25835: { suffiks: "_UTM35", bilder: "Geocache_UTM35_EUREF89", mork: !1 }
}, Ve = (e) => new ce({ url: `${qr}/GeocacheVector/${e}/VectorTileServer` }), Fe = (e, t) => new X({
  baseLayers: t,
  id: e.id,
  title: e.title,
  thumbnailUrl: e.thumbnailUrl ?? void 0
}), Ge = { 25832: Jr.basemaps.toArray() };
function fs(e) {
  if (!e)
    return [];
  if (Ge[e])
    return Ge[e];
  const t = wi[e];
  if (!t)
    return [];
  const r = [
    Fe(Br, [Ve(`GeocacheBasisTerreng${t.suffiks}`)]),
    Fe(Wr, [Ve(`GeocacheGraatoneTerreng${t.suffiks}`)]),
    Fe(Yr, [
      Ve(`GeocacheGraatoneTerreng${t.suffiks}`),
      new Or({ url: `${qr}/${t.bilder}/GeocacheBilder/MapServer` })
    ]),
    ...t.mork ? [Fe(Kr, [Ve(`GeocacheKanvasMork${t.suffiks}`)])] : []
  ];
  return Ge[e] = r, r;
}
const ki = {
  basis_terreng: "basemaps.basis",
  graatone_terreng: "basemaps.graatone",
  bilder: "basemaps.bilder",
  mork: "basemaps.mork"
};
function Si(e) {
  Object.values(Ge).flat().forEach((t) => {
    const r = ki[t.id ?? ""];
    r && (t.title = e.t(r, { ns: "map" }));
  });
}
const ae = Te("MapInit"), Ri = ({
  containerRef: e,
  mapMode: t,
  webMapId: r,
  webSceneId: n,
  basemapConfig: i,
  disablePopup: a,
  initialView: s,
  includeEiendomsGrenseLayer: l = !0,
  includeEiendomsTeigLayer: c = !0,
  includeSpesielleGrenserLayer: f = !1,
  onMapViewChange: u,
  onSceneViewChange: h
}) => {
  const w = J(null), E = J(s);
  return z(() => {
    if (!e.current)
      return;
    let p = null, _ = !1;
    const R = [
      { layer: vi, enabled: l },
      { layer: _i, enabled: f },
      { layer: vr, enabled: c }
    ];
    return (async () => {
      let v;
      if (t === _e.TwoD) {
        if (r)
          ae.debug("Initializing 2D MapView with webMap", r), v = new Vn({
            portalItem: {
              id: r
            }
          });
        else {
          ae.debug("Initializing 2D MapView with basemap config");
          const g = i ? new X(i) : new X({
            baseLayers: [
              new ce({
                url: "https://services.geodataonline.no/arcgis/rest/services/GeocacheVector/GeocacheBasisTerreng_UTM32/VectorTileServer"
              })
            ],
            id: "basis_terreng",
            title: "Basis Terreng"
          });
          v = new er({
            basemap: g
          });
        }
        w.current = v, ae.debug("Map instance created for 2D view");
        const b = E.current;
        p = new zn({
          container: e.current,
          map: v,
          popupEnabled: !a,
          ...b && {
            center: new Tr({ x: b.x, y: b.y, spatialReference: { wkid: b.wkid } }),
            zoom: b.zoom
          }
        }), p.when(() => {
          !_ && u && (u(p), c && (vr.outFields = ["id", "objectid", "gids"]), R.forEach(({ layer: g, enabled: y }) => {
            y && p?.map?.add(g);
          }));
        }).catch((g) => {
          ae.error("MapView failed to load:", g);
        });
      } else {
        if (n)
          ae.debug("Initializing 3D SceneView with webScene", n), v = new Fn({
            portalItem: {
              id: n
            }
          });
        else {
          ae.debug("Initializing 3D SceneView with basemap config");
          const b = i ? new X(i) : new X({
            baseLayers: [
              new ce({
                url: "https://services.geodataonline.no/arcgis/rest/services/GeocacheVector/GeocacheBasisTerreng_UTM32/VectorTileServer"
              })
            ],
            id: "basis_terreng",
            title: "Basis Terreng"
          });
          v = new er({
            basemap: b
          });
        }
        w.current = v, p = new Gn({
          container: e.current,
          map: v,
          popupEnabled: !a,
          center: [10.7522, 59.9139],
          zoom: 10
        }), p.when(() => {
          !_ && h && h(p);
        }).catch((b) => {
          ae.error("SceneView failed to load:", b);
        });
      }
    })(), () => {
      _ = !0;
      const v = w.current;
      if (v) {
        try {
          R.forEach(({ layer: b, enabled: g }) => {
            g && v.layers?.remove(b);
          });
        } catch {
        }
        try {
          v.basemap = null;
        } catch {
        }
      }
      w.current = null, t === _e.TwoD ? u?.(null) : h?.(null), p && !p.destroyed && p.destroy();
    };
  }, [t, e, r, n, i, l, c, f, u, h]), { mapRef: w };
};
function Ci(e) {
  const t = {
    position: "absolute",
    top: e.top || "0px",
    left: e.left || "0px",
    border: "none",
    boxShadow: "rgba(0, 0, 0, 0.3) 0px 1px 2px"
  };
  return /* @__PURE__ */ te.jsx(
    "input",
    {
      style: t,
      className: e.class,
      type: "button",
      id: e.id,
      value: e.value,
      onClick: e.onClick
    }
  );
}
const Ti = "Toggle between 2D and 3D view", Oi = "Map", xi = "Use the arrow keys to pan the map and the plus/minus keys to zoom in and out.", Mi = {
  basis: "Standard",
  graatone: "Grayscale",
  bilder: "Imagery",
  mork: "Dark"
}, Di = {
  huff: "Establishment analysis",
  property: "Property info",
  analysis: "Analysis area",
  streetview: "StreetView"
}, Pi = {
  label: "Area measurement",
  cancel: "Cancel measurement"
}, Ii = {
  filterPlaceholder: "Search for map layers..."
}, Ai = {
  toggleModeTooltip: Ti,
  mapAriaLabel: Oi,
  mapInstructions: xi,
  basemaps: Mi,
  popup: Di,
  measure: Pi,
  layerlist: Ii
}, Ni = "Bytt mellom 2D- og 3D-visning", ji = "Kart", Li = "Bruk piltastene for å panorere kartet og pluss/minus-tastene for å zoome inn og ut.", Vi = {
  basis: "Fargekart",
  graatone: "Gråtone",
  bilder: "Bilder",
  mork: "Mørkt"
}, Fi = {
  huff: "Etableringsanalyse",
  property: "Eiendomsinformasjon",
  analysis: "Analyseområde",
  streetview: "Gatebilder"
}, zi = {
  label: "Arealmåling",
  cancel: "Avbryt måling"
}, Gi = {
  filterPlaceholder: "Søk etter kartlag..."
}, $i = {
  toggleModeTooltip: Ni,
  mapAriaLabel: ji,
  mapInstructions: Li,
  basemaps: Vi,
  popup: Fi,
  measure: zi,
  layerlist: Gi
}, Ui = {
  nb: {
    map: $i
  },
  en: {
    map: Ai
  }
};
function Hi(e) {
  for (const [t, r] of Object.entries(Ui))
    e.hasResourceBundle(t, "map") || e.addResourceBundle(t, "map", r.map);
}
var j = /* @__PURE__ */ ((e) => (e.PropertyInfo = "propertyinformation", e.Planinformasjon = "planinformation", e.ShowArealplaner = "show-arealplaner", e.ToggleArealplaner = "toggle-arealplaner", e))(j || {});
const Xr = "Arealplaner", Qr = (e) => {
  let t = `${e.gardsnr}/${e.bruksnr}`;
  return e.festenr && (t += `/${e.festenr}`), e.seksjonsnr && (t += `/${e.seksjonsnr}`), t;
}, Zr = (e, t, r, n) => ({
  selected: !0,
  name: e,
  address: t.adresse || "",
  postalCode: "",
  postalArea: "",
  x: r.x,
  y: r.y,
  wkid: n.spatialReference.wkid ?? void 0,
  source: "mapClick",
  matrikkelEnhet: {
    gardsnr: t.gardsnr,
    bruksnr: t.bruksnr,
    festenr: t.festenr,
    seksjonsnr: t.seksjonsnr,
    kommunenr: String(t.kommunenr),
    kommunenavn: t.kommunenavn
  }
}), en = (e, t, r) => `Grunneiendom ${e} i ${t || ""} kommune (${r || ""})`;
var tn = /* @__PURE__ */ ((e) => (e.PLAN_ID = "PLANID", e.PLAN_NAVN = "PLANNAVN", e.PLAN_TYPE = "PLANTYPE", e.PLAN_STATUS = "PLANSTAT", e.PLAN_BESTEMMELSER = "PLANBEST", e.IKRAFTTREDELSESDATO = "IKRAFT", e.LOVREFERANSE = "LOVREFERANSE", e.PLAN_REGISTER_LINK = "PLANREGISTERLINK", e.VERTIKALNIVÅ = "VERTNIV", e.OBJTYPE = "OBJTYPE", e))(tn || {});
const Bi = Te("popupUtils"), Wi = (e, t) => !e || e === "null" ? t === "Eiendom" ? "" : "Eiendommen har flere adresser" : `Tilknyttet adresse: ${e}`, Ki = (e, t, r, n, i) => {
  const a = Wi(t, n), s = "Benytt knappene i verktøylinjen for å se matrikkelinformasjon om eiendommen og alle arealplaner som berører eiendommen";
  return e ? !r || Object.keys(r).length === 0 ? `
        <div style="font-family: 'Segoe UI', Roboto, Oxygen, Ubuntu, 'Helvetica Neue', sans-serif; padding: 1rem; background-color: #f9f9f9; border-radius: 8px; box-shadow: 0 2px 4px rgba(0,0,0,0.05);">
          <div style="font-size: 1.1rem; font-weight: 600; color: #333; margin-bottom: 8px;">${i}</div>
          <div style="font-size: 0.9rem; font-weight: 600; color: #333; margin-bottom: 8px;">${a}</div>
          <div style="font-size: 0.9rem; font-weight: 600; color: #333; margin: 12px 0 8px 0;">Finner ingen arealplaner i kartet</div>
          <div style="font-size: 0.75rem; color: #666; line-height: 1.4;">${s}</div>
        </div>
        ` : `
    <div style="font-family: 'Segoe UI', Roboto, Oxygen, Ubuntu, 'Helvetica Neue', sans-serif; padding: 1rem; background-color: #f9f9f9; border-radius: 8px; box-shadow: 0 2px 4px rgba(0,0,0,0.05);">
        <div style="font-size: 1.1rem; font-weight: 600; color: #333; margin-bottom: 8px;">${i}</div>
        <div style="font-size: 0.9rem; font-weight: 600; color: #333; margin-bottom: 8px;">${a}</div>
        <div style="font-size: 0.9rem; font-weight: 600; color: #333; margin: 12px 0 8px 0;">Arealplaner vist i kartet</div>
  
      <div>
        ${Object.entries(r).map(([l, c]) => {
    const f = c.attributes.PLANNAVN;
    return `
            <div style="margin: 0.5rem 0; padding: 0.5rem; background-color: white; border-radius: 4px; box-shadow: 0 1px 2px rgba(0,0,0,0.05); border: 1px solid #eee;">
              <div style="display: flex; align-items: center; justify-content: space-between; font-size: 0.9rem; color: #333;">
                <div>
                  <a href="${c.attributes.PLANREGISTERLINK}" target="_blank" style="color: #0066cc; text-decoration: none; font-weight: 500; border-bottom: 1px solid #0066cc;">${f ? `${f} (${l})` : l}</a>
                </div>
              </div>
            </div>
          `;
  }).join("")}
      </div>
    <div style="margin-top: 12px; font-size: 0.75rem; color: #666; line-height: 1.4;">${s}</div>
    </div>
  ` : `
        <div style="font-family: 'Segoe UI', Roboto, Oxygen, Ubuntu, 'Helvetica Neue', sans-serif; padding: 1rem; background-color: #f9f9f9; border-radius: 8px; box-shadow: 0 2px 4px rgba(0,0,0,0.05);">
          <div style="font-size: 1.1rem; font-weight: 600; color: #333; margin-bottom: 8px;">En feilsituasjon har oppstått, prøv igjen senere</div>
        </div>
        `;
}, Yi = (e, t) => {
  const r = e.graphic.attributes[tn.PLAN_ID];
  if (r) {
    t[r] || (t[r] = { PLANID: r, attributes: {} });
    for (const [n, i] of Object.entries(e.graphic.attributes))
      t[r].attributes[n] = i;
  }
  return t;
}, Ji = (e) => e.reduce(
  (t, r) => Yi(r, t),
  {}
), qi = (e) => e.filter(
  (t) => t.layer.type === "vector-tile" && t.type === "graphic"
), rn = async (e, t) => {
  try {
    const r = await e.hitTest(t);
    if (r.results.length) {
      const n = qi(r.results);
      return Ji(n);
    }
  } catch (r) {
    Bi.error(r.message);
  }
}, Qe = (e) => e.map?.allLayers.find((t) => t.title === Xr), Nt = (e, t) => e.popup?.actions.find((r) => r.id === t), Xi = (e, t) => {
  if (e.map)
    for (const r of e.map.allLayers)
      r.parent && "title" in r.parent && r.parent.title === t && (r.visible = !0);
}, Qi = Te("widgetUtils"), Zi = (e) => {
  if (!e.ui.find("location-analytics-fullscreen")) {
    const r = document.createElement("arcgis-fullscreen");
    r.id = "location-analytics-fullscreen", r.view = e, e.ui.add(r, { position: "top-right" });
  }
}, ea = async (e) => {
  try {
    const t = await e.takeScreenshot(), n = await (await fetch(t.dataUrl)).blob();
    await navigator.clipboard.write([
      new ClipboardItem({
        [n.type]: n
      })
    ]);
  } catch (t) {
    Qi.error("Failed to copy screenshot to clipboard:", t);
  }
}, ta = (e) => {
  if (!e.ui.find("location-analytics-copymap")) {
    const r = document.createElement("input");
    r.id = "location-analytics-copymap", r.type = "button", r.className = "esri-component esri-widget--button esri-widget esri-interactive", r.onclick = () => ea(e), e.ui.add(r, { position: "top-right" });
  }
}, ra = (e) => {
  e.ui.find("location-analytics-basemaps") || e.ui.add(new Ye({
    id: "location-analytics-basemaps",
    view: e,
    content: new Xn({
      view: e,
      source: Jr
    }),
    expandTooltip: "Bakgrunnskart",
    autoCollapse: !0,
    closeOnEsc: !0
  }), { position: "bottom-left" });
}, na = (e, t, { label: r, cancel: n }) => {
  const i = document.createElement("arcgis-area-measurement-2d");
  i.view = e, i.label = r;
  const a = document.createElement("calcite-button");
  a.appearance = "outline", a.kind = "neutral", a.width = "full", a.textContent = n;
  const s = document.createElement("div");
  s.style.padding = "0 var(--calcite-spacing-md) var(--calcite-spacing-md)", s.hidden = !0, s.appendChild(a);
  const l = document.createElement("div");
  l.append(i, s);
  const c = document.createElement("arcgis-expand");
  c.id = "location-analytics-measure", c.view = e, c.label = r, c.expandIcon = "measure-area", c.appendChild(l);
  let f = !1;
  const u = () => e.widthBreakpoint === "xsmall";
  let h = !1;
  const w = () => {
    s.hidden = !(h && u());
  }, E = (y) => {
    h = y, w();
  };
  e.addHandles(q.watch(() => e.widthBreakpoint, w), "location-analytics");
  let p = !1, _ = !1, R = i.state, C = 0;
  const v = async () => {
    E(!0);
    const y = ++C;
    await q.whenOnce(() => e.ready);
    const { spatialReference: k } = e;
    (k?.isGeographic || k?.isWebMercator) && await Promise.all([
      to.load(),
      ro.load(),
      no.load()
    ]), !(y !== C || !(c.expanded || f)) && i.start();
  }, b = () => {
    C++, E(!1), _ = !0, l.style.visibility = "hidden", i.clear().finally(() => {
      _ = !1;
    });
  };
  i.addEventListener("arcgisPropertyChange", (y) => {
    if (y.detail.name !== "state")
      return;
    const k = i.state;
    k === "measuring" ? E(!0) : k === "measured" || k === "ready" && R === "measuring" ? (E(!1), f && c.expand()) : k === "ready" && R === "measured" && !_ && E(!0), R = k;
  });
  const g = {
    remove: () => {
      C++, e.ui.container && (e.ui.container.style.zIndex = ""), (c.expanded || f) && t(!1);
    }
  };
  e.addHandles(g, "location-analytics"), c.addEventListener("arcgisPropertyChange", (y) => {
    if (y.detail.name === "expanded") {
      if (e.ui.container && (e.ui.container.style.zIndex = c.expanded && u() ? "2" : ""), c.expanded) {
        f = !1, l.style.visibility = "", t(!0), !h && i.state === "ready" && v();
        return;
      }
      if (u() && h && !p) {
        f = !0;
        return;
      }
      p = !1, f = !1, t(!1), b();
    }
  }), a.addEventListener("click", () => {
    p = !0, c.collapse();
  }), e.ui.add(c, { position: "top-right" });
}, oa = (e, t, r) => {
  const n = new Ye({
    id: "location-analytics-measure",
    view: e,
    expandTooltip: r,
    content: new Qn({ view: e, label: r })
  });
  e.ui.add(n, { position: "top-right" }), q.when(() => n.expanded === !1, () => {
    n.content.viewModel.clear();
  });
  const i = q.watch(() => n.expanded, (a) => {
    a ? t(!0) : (t(!1), n.content.viewModel.clear());
  });
  n.addHandles(i);
}, ia = (e, t, r) => {
  e.ui.find("location-analytics-measure") || (e.type === "2d" ? na(e, t, r) : oa(e, t, r.label));
}, aa = (e) => {
  if (!e.ui.find("location-analytics-daylight") && e.type === "3d") {
    const r = new Ye({
      id: "location-analytics-daylight",
      view: e,
      content: new Zn({
        view: e
      })
    });
    e.ui.add(r, { position: "top-right" });
  }
}, sa = (e) => {
  if (!e.ui.find("location-analytics-shadow") && e.type === "3d") {
    const r = new Ye({
      id: "location-analytics-shadow",
      view: e,
      expandIcon: "measure-building-height-shadow"
    });
    e.ui.add(r, { position: "top-right" }), q.watch(() => r.expanded, (n) => {
      n ? r.content = new eo({
        view: e
      }) : r.content && r.content.destroy();
    });
  }
}, ca = (e) => {
  if (!e.ui.find("location-analytics-scalebar")) {
    const r = document.createElement("arcgis-scale-bar");
    r.id = "location-analytics-scalebar", r.view = e, r.unit = "metric", e.ui.add(r, { position: "bottom-left" });
  }
}, la = (e, t) => {
  e.popup?.actions.push(new $e({
    title: t("popup.property"),
    id: j.PropertyInfo,
    icon: "locator"
  })), e.popup?.actions.push(new $e({
    title: "Arealplaner for eiendommen",
    id: j.Planinformasjon,
    icon: "classify-objects"
  }));
}, ua = (e) => {
  const t = Qe(e), r = t?.visible ?? !1;
  if (e.popup?.actions.push(new $e({
    title: "Arealplaner",
    id: j.ToggleArealplaner,
    icon: r ? "view-visible" : "view-hide"
  })), e.popup?.actions.push(new $e({
    title: "Vis alle arealplaner",
    id: j.ShowArealplaner,
    icon: "show-multiple-layers-at-a-time"
  })), t) {
    const n = q.watch(
      () => t.visible,
      (i) => {
        const a = Nt(e, j.ToggleArealplaner);
        a && (a.icon = i ? "view-visible" : "view-hide");
      }
    );
    e.addHandles(n, "arealplaner-visibility");
  }
}, da = (e) => {
  const t = q.on(
    () => e.popup,
    "open",
    () => {
      const n = Qe(e);
      if (n) {
        const i = Nt(e, j.ToggleArealplaner);
        i && (i.icon = n.visible ? "view-visible" : "view-hide");
      }
    }
  );
  e.addHandles(t, "location-analytics");
  const r = q.on(
    () => e.popup,
    "close",
    () => {
      e.removeHandles("arealplaner-visibility");
    }
  );
  e.addHandles(r, "location-analytics");
}, fa = (e, t, r, n) => {
  const i = Qe(e);
  if (!i)
    return !1;
  const a = i.visible;
  return i.visible = !a, t.action.title = "Arealplaner", t.action.icon = a ? "view-hide" : "view-visible", r ? (e.popup?.close(), n(e, r, !1), !0) : !1;
}, pa = (e, t, r) => {
  const n = Qe(e);
  if (!n)
    return !1;
  Xi(e, Xr), n.visible = !0;
  const i = Nt(e, j.ToggleArealplaner);
  return i && (i.title = "Arealplaner", i.icon = "view-visible"), t ? (e.popup?.close(), r(e, t, !1), !0) : !1;
}, Re = Te("mapUtils"), ma = async (e, t, r, n, i) => {
  const a = e.matrikkelInfo, s = Qr(a), l = a.adresse || e?.address || "", c = en(s, a.kommunenavn, a.kommunenr);
  if (i) {
    const u = Zr(s, a, t, r);
    i(u);
  }
  const f = await rn(r, n);
  return { matrikkelEnhet: s, adresse: l, heading: c, planer: f };
}, ya = async (e, t, r, n, i, a) => {
  const s = a ? a.getMatrikkelEnhetFromGeometry(e) : Promise.resolve([]), l = rn(t, r), c = await Promise.allSettled([s, l]), f = c[0], u = c[1];
  let h = "", w = n?.address || "", E = n?.name || "Resultat", p;
  if (f.status === "fulfilled" && f.value.length > 0) {
    const _ = f.value[0];
    if (h = Qr(_), w = _.adresse || w, E = en(h, _.kommunenavn, _.kommunenr), i) {
      const R = Zr(h, _, e, t);
      i(R);
    }
  } else
    n && (h = n.name || "");
  return u.status === "fulfilled" && (p = u.value), { matrikkelEnhet: h, adresse: w, heading: E, planer: p };
}, nn = async (e, t, r, n, i, a, s) => {
  try {
    let l;
    n?.matrikkelInfo ? l = await ma(
      n,
      t,
      e,
      r,
      a
    ) : l = await ya(
      t,
      e,
      r,
      n,
      a,
      s
    );
    const { matrikkelEnhet: c, adresse: f, heading: u, planer: h } = l;
    return i || e.openPopup({
      title: "Resultat fra søk",
      content: Ki(c, f, h, n?.searchType, u),
      location: t
    }), { matrikkelEnhet: c, adresse: f, planer: h };
  } catch (l) {
    throw Re.error("Feil under behandling av lokasjon:", l), l;
  }
}, Ce = "location-analytics-click", Tt = (e, t, r, n, i) => {
  e.removeHandles(Ce);
  const a = e.on("click", function(s) {
    if (n())
      return;
    const c = document.getElementById("origo-map-container");
    c && (c.style.cursor = "wait"), nn(
      e,
      s.mapPoint,
      s,
      void 0,
      t,
      r,
      i
    ).catch((f) => {
      Re.error("Feil under behandling av klikk:", f);
    }).finally(() => {
      c && (c.style.cursor = "default");
    });
  });
  return e.addHandles(a, Ce), a;
}, Er = async (e, t, r) => {
  if (r)
    return;
  const n = new Tr({
    x: t.x,
    y: t.y,
    spatialReference: { wkid: t.wkid || e.spatialReference.wkid }
  }), i = e.toScreen(n);
  if (!i) {
    Re.error("Kunne ikke konvertere punkt til skjermkoordinater");
    return;
  }
  try {
    await nn(
      e,
      n,
      i,
      {
        name: t.name,
        address: t.address,
        matrikkelInfo: t.matrikkelEnhet ? {
          gardsnr: t.matrikkelEnhet.gardsnr,
          bruksnr: t.matrikkelEnhet.bruksnr,
          festenr: t.matrikkelEnhet.festenr,
          seksjonsnr: t.matrikkelEnhet.seksjonsnr,
          kommunenr: t.matrikkelEnhet.kommunenr || "",
          kommunenavn: t.matrikkelEnhet.kommunenavn || ""
        } : void 0
      },
      r
    );
  } catch (a) {
    Re.error("Feil under åpning av popup:", a);
  }
}, ha = (e) => e?.includes(j.PropertyInfo) ?? !1, _r = (e, t, r, n, i, a = !1) => {
  const s = q.when(() => e.popup?.actions, () => {
    const c = e.popup?.actions.filter(
      (f) => f.id === j.PropertyInfo || f.id === j.Planinformasjon || f.id === j.ShowArealplaner
    );
    c && c.length > 0 || (e.popup?.viewModel && (e.popup.viewModel.includeDefaultActions = !1), e.popup && (e.popup.dockOptions.position = "bottom-right"), ha(t) && la(e, i), a || ua(e));
  });
  e.addHandles(s, "location-analytics"), a || da(e);
  const l = q.on(
    () => e.popup,
    "trigger-action",
    (c) => {
      if (c.action.id === j.PropertyInfo)
        r({ widgetId: j.PropertyInfo, keepOpen: !0, layoutPosition: "left" });
      else if (c.action.id === j.Planinformasjon)
        r({ widgetId: j.Planinformasjon, keepOpen: !0, layoutPosition: "left" });
      else if (!a && c.action.id === j.ToggleArealplaner) {
        if (fa(e, c, n(), Er))
          return;
      } else if (!a && c.action.id === j.ShowArealplaner && pa(e, n(), Er))
        return;
      e.popup?.close();
    }
  );
  e.addHandles(l, "location-analytics");
}, wr = (e, t, r, n) => {
  t && (t.includes("fullscreen") && Zi(e), t.includes("copymap") && ta(e), t.includes("basemaps") && ra(e), t.includes("measure") && ia(e, r, n), t.includes("daylight") && aa(e), t.includes("shadow") && sa(e), t.includes("scalebar") && ca(e));
}, kr = (e, t) => {
  if (t)
    for (const r of t) {
      const n = e.ui.find("location-analytics-" + r);
      if (n) {
        e.ui.remove(n);
        try {
          n.destroy();
        } catch (i) {
          Re.warn(`Failed to destroy widget ${r}:`, i);
        }
      }
    }
}, Sr = (e) => {
  e.popup && (e.popup.dockEnabled = !0, e.popup.dockOptions = {
    buttonEnabled: !0,
    breakpoint: !0,
    position: "bottom-right"
  });
}, ht = Te("Map");
function ps(e) {
  const { t, i18n: r } = jn("map");
  Hi(r);
  const {
    disableMapClick: n,
    selectedLocation: i,
    setDisableMapClick: a,
    setSelectedLocation: s
  } = Hr(), l = J(null), c = J(n);
  z(() => {
    c.current = n;
  }, [n]);
  const f = J(i);
  z(() => {
    f.current = i;
  }, [i]);
  const u = J(e.onActiveWidgetChange);
  z(() => {
    u.current = e.onActiveWidgetChange;
  }, [e.onActiveWidgetChange]);
  const h = e.tools2D?.join(","), w = e.tools3D?.join(","), E = e.widgetItems?.map((H) => H.widget).join(","), p = ze(() => e.tools2D, [h]), _ = ze(() => e.tools3D, [w]), R = ze(() => e.widgetItems?.map((H) => H.widget), [E]), C = !!e.onActiveWidgetChange, v = ne(() => f.current ?? void 0, []), b = ne((H) => u.current?.(H), []), {
    mapView: g,
    sceneView: y,
    mapMode: k,
    toggleMapMode: M,
    setMapView: P,
    setSceneView: $
  } = _o();
  Ri({
    containerRef: l,
    mapMode: k,
    webMapId: e.webMapId,
    webSceneId: e.webSceneId,
    disablePopup: e.disablePopup,
    initialView: e.initialView,
    includeEiendomsGrenseLayer: e.includeEiendomsGrenseLayer,
    includeEiendomsTeigLayer: e.includeEiendomsTeigLayer,
    includeSpesielleGrenserLayer: e.includeSpesielleGrenserLayer,
    onMapViewChange: P,
    onSceneViewChange: $
  }), z(() => {
    e.disable3D && k === _e.ThreeD && M();
  }, [e.disable3D, k, M]), z(() => {
    if (ht.debug("MapView setup effect, mapView ready:", !!g), !(!g || g.destroyed))
      return g.aria = {
        label: t("mapAriaLabel"),
        description: t("mapInstructions")
      }, Sr(g), wr(g, p, a, { label: t("measure.label"), cancel: t("measure.cancel") }), e.disableClick || (ht.debug("Adding view click handler"), Tt(
        g,
        e.disablePopup,
        s,
        () => c.current,
        e.matrikkelClient
      )), R && C && _r(
        g,
        R,
        b,
        v,
        t,
        !0
      ), () => {
        g.destroyed || (ht.debug("Cleaning up mapView"), g.removeHandles(Ce), g.removeHandles("location-analytics"), p && kr(g, p));
      };
  }, [
    g,
    e.disablePopup,
    e.disableClick,
    p,
    R,
    C,
    e.matrikkelClient,
    s,
    a,
    v,
    b,
    t
  ]), z(() => (y && !y.destroyed && (y.aria = {
    label: t("mapAriaLabel"),
    description: t("mapInstructions")
  }, Sr(y), wr(y, _, a, { label: t("measure.label"), cancel: t("measure.cancel") }), Tt(
    y,
    e.disablePopup,
    s,
    () => c.current,
    e.matrikkelClient
  ), R && C && _r(
    y,
    R,
    b,
    v,
    t,
    !0
  )), () => {
    !y || y.destroyed || (y.removeHandles(Ce), y.removeHandles("location-analytics"), _ && kr(y, _));
  }), [
    y,
    e.disablePopup,
    _,
    R,
    C,
    e.matrikkelClient,
    s,
    a,
    v,
    b,
    t
  ]);
  const K = () => {
    M();
  };
  return /* @__PURE__ */ te.jsxs("div", { className: "map-container", children: [
    /* @__PURE__ */ te.jsx("div", { id: "origo-map-container", className: "esri-map-container", role: "region", "aria-label": t("mapAriaLabel"), ref: l }),
    !e.disable3D && /* @__PURE__ */ te.jsxs(te.Fragment, { children: [
      /* @__PURE__ */ te.jsx(
        Ci,
        {
          top: "15px",
          left: "55px",
          class: "esri-component esri-widget--button esri-widget esri-interactive",
          id: "map-mode-toggle-button",
          value: k === _e.TwoD ? "3D" : "2D",
          onClick: K
        }
      ),
      /* @__PURE__ */ te.jsx(Ln, { referenceElement: "map-mode-toggle-button", placement: "right", children: t("toggleModeTooltip") })
    ] }),
    e.children
  ] });
}
const ms = (e, t, r) => {
  const { disableMapClick: n, setSelectedLocation: i } = Hr(), a = J(() => n);
  z(() => {
    a.current = () => n;
  }, [n]), z(() => {
    if (e)
      return Tt(
        e,
        t,
        i,
        () => a.current(),
        // Always get fresh value
        r
      ), () => {
        e.removeHandles(Ce);
      };
  }, [e, t, i, r]);
};
let Rr = !1;
function ys(e) {
  if (Rr)
    return;
  Rr = !0;
  const t = () => {
    e.hasResourceBundle(e.language, "map") && Si(e);
  };
  e.isInitialized && t(), e.on("initialized", t), e.on("languageChanged", t), e.on("loaded", t);
}
export {
  Xr as AREALPLANER_LAYER_NAME,
  ps as Map,
  _e as MapMode,
  j as MapPopupActions,
  Ci as MapTool,
  Qa as MapViewProvider,
  ss as addToLocationHistory,
  Tt as addViewClickHandler,
  Jr as basemaps,
  fs as basemapsForWkid,
  Sr as configurePopup,
  vo as goToWithInset,
  ts as highlightedAreaSymbol,
  ys as initMapContext,
  $r as mapSlice,
  Ui as mapTranslation,
  rs as secondaryPolygonSymbol,
  Ur as selectDisableMapClick,
  us as selectLocationHistory,
  bi as selectSelectedLocation,
  es as selectedPointSymbol,
  Za as selectedPolygonSymbol,
  gi as setDisableMapClick,
  ls as setHighlightGeometries,
  hi as setSelectedLocation,
  Si as updateBasemapTitles,
  ds as useDisableMapClick,
  ms as useMapClickHandler,
  Hr as useMapState,
  _o as useMapViewContext
};
//# sourceMappingURL=index.mjs.map
